import { SearchableDropdown } from '../helpers/SearchableDropdown';
import { Dropdown } from '../helpers/Dropdown';
import React, { useState } from 'react';
import './BrandingPage.scss';
import {
    DownloadIcon,
} from '../ui/svg/DownloadIcon';

// JavaScript Functions
function BrandingPage() {
    // fields
    const [inputValueNotRequired, setInputValueNotRequired] = useState('');
    const [longInputValueNil, setLongInputValueNil] = useState('');
    const [longInputValue, setLongInputValue] = useState('');
    const [inputValueNil, setInputValueNil] = useState('');
    const [showTooltip, setShowTooltip] = useState(false);
    const [inputValue, setInputValue] = useState('');
    const longCharacterLimit = 200;
    const characterLimit = 20;

    // single dropdown
    const options = [
        { value: 1, label: 'Option 1' },
        { value: 2, label: 'Option 2' },
        { value: 3, label: 'Option 3' },
    ];

    const [selectedOption, setSelectedOption] = useState(null);

    const handleDropdownChange2 = option => {
        setSelectedOption(option);
    };

    // tab change
    const changeTab = tabNumber => {
        // Reset all tabs to default styles
        const tabs = document.getElementsByClassName('ing-bottom-tab');
        for (let i = 0; i < tabs.length; i++) {
            tabs[i].classList.remove('active');
        }

        // Set the clicked tab to active
        const clickedTab = document.querySelector(
            `.ing-bottom-tab:nth-child(${tabNumber})`,
        );
        clickedTab.classList.add('active');
    };

    // copy scss class to keyboard
    const getSCSSValue = event => {
        const textToCopy = event.target.innerText;
        navigator.clipboard
            .writeText(textToCopy)
            .then(() => {
                console.log(`Copied to clipboard: ${textToCopy}`);
            })
            .catch(error => {
                console.error('Failed to copy to clipboard:', error);
            });
    };

    const handleInputChange = event => {
        const value = event.target.value;
        if (value.length <= characterLimit) {
            setInputValue(value);
        }
    };

    const handleLongInputChange = event => {
        const value = event.target.value;
        if (value.length <= longCharacterLimit) {
            setLongInputValue(value);
        }
    };

    // updates input field word count
    const handleInputChangeNotRequired = event => {
        const value = event.target.value;
        if (value.length <= longCharacterLimit) {
            setInputValueNotRequired(value);
        }
    };

    // updates input field dropdown
    const handleDropdownChange = event => { };

    /* HTML CODE */
    return (
        <div className="page-content">
            <div className="ing-card">
                <div className="card-body px-0 py-4">
                    <div className="d-flex">
                        {/* TABLE OF CONTENTS */}
                        <div className="list-container">
                            <a
                                href="https://www.figma.com/design/sZkGn2dTLeyfzhXupoTbYY/Style-Guide---iNGAGED?node-id=0-1&t=3Jmys3OxfoRl7Qi6-0"
                                target="_blank"
                            >
                                <img
                                    src="/ingaged3.png"
                                    alt="Image Description"
                                    className="logo"
                                />
                            </a>
                            <ul>
                                <li>
                                    <strong>Colors</strong>
                                </li>
                                <li>
                                    <a href="#primary">Primary</a>
                                </li>
                                <li>
                                    <a href="#accent">Accent</a>
                                </li>
                                <li>
                                    <a href="#warning">Warning</a>
                                </li>
                                <li>
                                    <a href="#information-select">
                                        Information / Select
                                    </a>
                                </li>
                                <li>
                                    <a href="#destructive-required">
                                        Destructive / Required
                                    </a>
                                </li>
                                <li>
                                    <a href="#success">Success</a>
                                </li>
                                <li>
                                    <a href="#neutrals">Neutrals</a>
                                </li>
                                <li>
                                    <a href="#gradient">Gradient</a>
                                </li>
                            </ul>
                            <ul>
                                <li>
                                    <strong>Text</strong>
                                </li>
                                <li>
                                    <a href="#display">Displays</a>
                                </li>
                                <li>
                                    <a href="#heading">Headings</a>
                                </li>
                                <li>
                                    <a href="#paragraph">Paragraph</a>
                                </li>
                                <li>
                                    <a href="#body">Body</a>
                                </li>
                            </ul>
                            <ul>
                                <li>
                                    <strong>Buttons</strong>
                                </li>
                                <li>
                                    <a href="#primaryaction">Primary</a>
                                </li>
                                <li>
                                    <a href="#textbuttons">Text</a>
                                </li>
                                <li>
                                    <a href="#popUpButtons">Pop-up</a>
                                </li>
                                <li>
                                    <a href="#tool-tips">Tool-Tips</a>
                                </li>
                                <li>
                                    <a href="#tags">Tags</a>
                                </li>
                            </ul>

                            <ul>
                                <li>
                                    <strong>Icons</strong>
                                </li>
                                <li>
                                    <a href="#icons">Bootstrap</a>
                                </li>
                            </ul>

                            <ul>
                                <li>
                                    <strong>Forms</strong>
                                </li>
                                <li>
                                    <a href="#inputfields">Input Fields</a>
                                </li>
                                <li>
                                    <a href="#dropdowns">Dropdowns</a>
                                </li>
                                <li>
                                    <a href="#checkboxes">Check Boxes</a>
                                </li>
                                <li>
                                    <a href="#radiobtns">Radio Buttons</a>
                                </li>
                                <li>
                                    <a href="#toggles">Toggles</a>
                                </li>
                            </ul>

                            <ul>
                                <li>
                                    <strong>Alerts</strong>
                                </li>
                                <li>
                                    <a href="#validations">Validations</a>
                                </li>
                                <li>
                                    <a href="#messaging">Messaging</a>
                                </li>
                                <li>
                                    <a href="#popups">Pop Up</a>
                                </li>
                                <li>
                                    <a href="#confirm">Confirm</a>
                                </li>
                                <li>
                                    <a href="#confirm">Toasts</a>
                                </li>
                            </ul>
                        </div>
                        {/* END TABLE OF CONTENTS */}

                        <div className="subtitle-container">
                            <div className="sticky-header">
                                <div className="header-text">
                                    <div className="shape-container">
                                        <h2 className="iNGAGED-Typography-Paragraph">
                                            UI Style Guide
                                        </h2>
                                        <div className="shape">
                                            <span className="shape-text">
                                                V1
                                            </span>
                                        </div>
                                    </div>
                                    <h2 className="iNGAGED-Typography-Heading5">
                                        Official iNGAGED Style Guide with SCSS
                                        classes
                                    </h2>
                                </div>
                            </div>
                            <div id="primary">
                                <h2 className="iNGAGED-Typography-Heading1 iNGAGED-Primary-Color">
                                    <span className="bold-text">| Colors</span>
                                </h2>
                                <h2 className="iNGAGED-Typography-Heading5">
                                    Color styles represent iNGAGED default theme
                                    colors.
                                </h2>
                                <br />
                                <h2 className="iNGAGED-Typography-Heading3">
                                    <span className="bold-text">Primary</span>
                                </h2>
                                <h2 className="iNGAGED-Typography-Heading5">
                                    The Primary color palette is used across all
                                    interactive elements such as CTA's, links,
                                    inputs, etc.
                                </h2>
                                <hr />

                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="41"
                                    height="56"
                                    viewBox="0 0 41 56"
                                    fill="none"
                                >
                                    <g clip-path="url(#clip0_77767_1772)">
                                        <path
                                            fill-rule="evenodd"
                                            clip-rule="evenodd"
                                            d="M4 0C1.79 0 0 1.79 0 4V52C0 54.21 1.79 56 4 56H36.52C38.73 56 40.52 54.21 40.52 52V12.53L27.69 0H4Z"
                                            fill="#054F32"
                                        />
                                        <path
                                            d="M28.03 12.53C27.02 11.79 27.69 0 27.69 0L40.52 12.53C40.52 12.53 29.38 13.51 28.03 12.53Z"
                                            fill="#6FC5A4"
                                        />
                                        <path
                                            d="M35.18 44.46L32.81 51.01H31.45L29.07 44.46H30.44L32.1 49.5H32.17L33.82 44.46H35.19H35.18ZM28.05 46.05L26.9 46.25C26.85 46.1 26.78 45.96 26.67 45.83C26.57 45.7 26.43 45.59 26.25 45.5C26.07 45.41 25.85 45.37 25.59 45.37C25.23 45.37 24.93 45.45 24.69 45.61C24.45 45.77 24.33 45.98 24.33 46.23C24.33 46.45 24.41 46.62 24.57 46.76C24.73 46.89 24.99 47 25.35 47.09L26.39 47.33C26.99 47.47 27.44 47.68 27.74 47.97C28.04 48.26 28.18 48.64 28.18 49.1C28.18 49.49 28.07 49.84 27.84 50.15C27.62 50.45 27.3 50.69 26.9 50.87C26.5 51.04 26.03 51.13 25.51 51.13C24.78 51.13 24.18 50.97 23.72 50.66C23.26 50.34 22.97 49.9 22.87 49.32L24.1 49.13C24.18 49.45 24.33 49.69 24.57 49.86C24.81 50.02 25.12 50.1 25.5 50.1C25.92 50.1 26.25 50.01 26.5 49.84C26.75 49.66 26.88 49.45 26.88 49.2C26.88 49 26.8 48.82 26.65 48.68C26.5 48.54 26.27 48.44 25.96 48.36L24.85 48.12C24.24 47.98 23.79 47.76 23.49 47.46C23.2 47.16 23.06 46.77 23.06 46.31C23.06 45.92 23.17 45.59 23.38 45.3C23.6 45.01 23.89 44.78 24.27 44.62C24.65 44.46 25.09 44.37 25.58 44.37C26.29 44.37 26.84 44.52 27.25 44.83C27.66 45.13 27.92 45.54 28.06 46.05H28.05ZM19.09 51.13C18.46 51.13 17.91 50.99 17.45 50.7C17 50.41 16.65 50.01 16.4 49.5C16.16 48.99 16.03 48.41 16.03 47.75C16.03 47.09 16.15 46.5 16.41 45.99C16.66 45.48 17.01 45.08 17.47 44.79C17.92 44.5 18.46 44.36 19.08 44.36C19.58 44.36 20.02 44.45 20.41 44.64C20.8 44.82 21.11 45.08 21.35 45.41C21.59 45.74 21.74 46.12 21.78 46.56H20.54C20.47 46.25 20.32 45.99 20.07 45.77C19.83 45.55 19.5 45.44 19.1 45.44C18.74 45.44 18.43 45.53 18.17 45.72C17.91 45.9 17.7 46.17 17.55 46.51C17.4 46.85 17.33 47.25 17.33 47.72C17.33 48.19 17.4 48.61 17.55 48.96C17.69 49.31 17.9 49.57 18.16 49.77C18.43 49.96 18.74 50.06 19.1 50.06C19.34 50.06 19.56 50.02 19.76 49.93C19.96 49.84 20.12 49.71 20.26 49.54C20.4 49.37 20.49 49.17 20.55 48.93H21.79C21.74 49.35 21.61 49.73 21.38 50.06C21.15 50.39 20.84 50.65 20.46 50.84C20.08 51.03 19.63 51.13 19.11 51.13H19.09Z"
                                            fill="white"
                                        />
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_77767_1772">
                                            <rect
                                                width="40.52"
                                                height="56"
                                                fill="white"
                                            />
                                        </clipPath>
                                    </defs>
                                </svg>

                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="41"
                                    height="56"
                                    viewBox="0 0 41 56"
                                    fill="none"
                                >
                                    <g clip-path="url(#clip0_77768_1808)">
                                        <path
                                            fill-rule="evenodd"
                                            clip-rule="evenodd"
                                            d="M4 0C1.79 0 0 1.79 0 4V52C0 54.21 1.79 56 4 56H36.52C38.73 56 40.52 54.21 40.52 52V12.53L27.69 0H4Z"
                                            fill="#B8B7B7"
                                        />
                                        <path
                                            d="M28.03 12.53C27.02 11.79 27.69 0 27.69 0L40.52 12.53C40.52 12.53 29.38 13.51 28.03 12.53Z"
                                            fill="#D9D9D9"
                                        />
                                        <path
                                            d="M25.81 47.73L27.85 44.46H26.46L25 47.01L23.56 44.46H22.16L24.17 47.73L22.13 51H23.53L25 48.56L26.48 51H27.87L25.81 47.73Z"
                                            fill="white"
                                        />
                                        <path
                                            d="M32.34 50.95C32.26 50.98 32.16 51.01 32.02 51.04C31.88 51.07 31.71 51.09 31.51 51.09C31.17 51.09 30.86 51.03 30.57 50.91C30.28 50.78 30.05 50.59 29.87 50.33C29.69 50.07 29.6 49.74 29.6 49.35V45.48H28.64V44.46H29.6V42.89H30.87V44.46H32.22V45.48H30.87V49.08C30.87 49.33 30.91 49.51 30.99 49.64C31.06 49.76 31.15 49.85 31.27 49.89C31.39 49.93 31.52 49.95 31.66 49.95C31.76 49.95 31.85 49.95 31.93 49.93C32 49.92 32.06 49.91 32.11 49.9L32.34 50.95Z"
                                            fill="white"
                                        />
                                        <path
                                            d="M21.26 50.95C21.19 50.98 21.08 51.01 20.95 51.04C20.81 51.07 20.64 51.09 20.43 51.09C20.1 51.09 19.79 51.03 19.5 50.91C19.21 50.78 18.97 50.59 18.79 50.33C18.62 50.07 18.53 49.74 18.53 49.35V45.48H17.57V44.46H18.53V42.89H19.8V44.46H21.14V45.48H19.8V49.08C19.8 49.33 19.84 49.51 19.91 49.64C19.98 49.76 20.08 49.85 20.2 49.89C20.32 49.93 20.44 49.95 20.58 49.95C20.69 49.95 20.78 49.95 20.85 49.93C20.93 49.92 20.99 49.91 21.03 49.9L21.26 50.95Z"
                                            fill="white"
                                        />
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_77768_1808">
                                            <rect
                                                width="40.52"
                                                height="56"
                                                fill="white"
                                            />
                                        </clipPath>
                                    </defs>
                                </svg>

                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="41"
                                    height="56"
                                    viewBox="0 0 41 56"
                                    fill="none"
                                >
                                    <g clip-path="url(#clip0_77768_1814)">
                                        <path
                                            fill-rule="evenodd"
                                            clip-rule="evenodd"
                                            d="M4 0C1.79 0 0 1.79 0 4V52C0 54.21 1.79 56 4 56H36.52C38.73 56 40.52 54.21 40.52 52V12.53L27.69 0H4Z"
                                            fill="#C11010"
                                        />
                                        <path
                                            d="M28.03 12.53C27.02 11.79 27.69 0 27.69 0L40.52 12.53C40.52 12.53 29.38 13.51 28.03 12.53Z"
                                            fill="#FF8585"
                                        />
                                        <path
                                            d="M28.01 42.28V45.52H27.93C27.85 45.38 27.75 45.22 27.61 45.05C27.47 44.87 27.28 44.71 27.03 44.58C26.78 44.44 26.45 44.37 26.05 44.37C25.52 44.37 25.05 44.51 24.64 44.77C24.22 45.04 23.9 45.42 23.66 45.93C23.42 46.43 23.3 47.04 23.3 47.74C23.3 48.44 23.42 49.06 23.65 49.56C23.89 50.07 24.21 50.45 24.62 50.73C25.04 51 25.51 51.13 26.04 51.13C26.44 51.13 26.76 51.06 27.01 50.93C27.26 50.8 27.46 50.64 27.6 50.46C27.74 50.28 27.85 50.12 27.93 49.98H28.04V51H29.28V42.28H28.01ZM27.83 48.94C27.7 49.29 27.51 49.56 27.25 49.75C27 49.95 26.69 50.04 26.32 50.04C25.95 50.04 25.62 49.94 25.37 49.74C25.11 49.54 24.92 49.26 24.79 48.91C24.66 48.56 24.59 48.17 24.59 47.73C24.59 47.29 24.65 46.91 24.78 46.57C24.91 46.22 25.11 45.95 25.36 45.75C25.62 45.55 25.94 45.45 26.32 45.45C26.7 45.45 27.01 45.55 27.26 45.74C27.51 45.93 27.7 46.2 27.83 46.54C27.96 46.88 28.03 47.28 28.03 47.73C28.03 48.18 27.96 48.59 27.83 48.94ZM21.8 45.93C21.57 45.42 21.24 45.04 20.83 44.77C20.41 44.51 19.94 44.37 19.41 44.37C19.01 44.37 18.68 44.44 18.43 44.58C18.19 44.71 17.99 44.87 17.85 45.05C17.71 45.22 17.61 45.38 17.53 45.52H17.43V44.46H16.18V53.46H17.46V49.98H17.53C17.61 50.12 17.72 50.28 17.86 50.46C18 50.64 18.2 50.8 18.45 50.93C18.7 51.06 19.03 51.13 19.43 51.13C19.95 51.13 20.42 51 20.84 50.73C21.25 50.45 21.57 50.07 21.81 49.56C22.04 49.06 22.16 48.45 22.16 47.74C22.16 47.03 22.04 46.43 21.8 45.93ZM20.67 48.91C20.54 49.26 20.35 49.54 20.09 49.74C19.84 49.94 19.52 50.04 19.14 50.04C18.76 50.04 18.46 49.95 18.21 49.75C17.96 49.56 17.77 49.29 17.63 48.94C17.5 48.59 17.43 48.19 17.43 47.73C17.43 47.27 17.5 46.88 17.63 46.54C17.76 46.2 17.95 45.93 18.2 45.74C18.46 45.55 18.77 45.45 19.14 45.45C19.51 45.45 19.84 45.55 20.1 45.75C20.36 45.95 20.55 46.22 20.68 46.57C20.81 46.91 20.87 47.3 20.87 47.73C20.87 48.16 20.81 48.56 20.67 48.91Z"
                                            fill="white"
                                        />
                                        <path
                                            d="M32.81 43.87V44.46H34.22V45.48H32.81V51H31.53V45.48H30.52V44.46H31.53V43.7C31.53 43.29 31.62 42.95 31.8 42.68C31.98 42.41 32.22 42.2 32.51 42.07C32.81 41.93 33.13 41.87 33.47 41.87C33.73 41.87 33.95 41.89 34.13 41.93C34.31 41.97 34.45 42.01 34.54 42.04L34.24 43.07C34.18 43.06 34.1 43.04 34.01 43.01C33.91 42.99 33.8 42.97 33.67 42.97C33.36 42.97 33.13 43.05 33 43.2C32.87 43.36 32.81 43.58 32.81 43.87Z"
                                            fill="white"
                                        />
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_77768_1814">
                                            <rect
                                                width="40.52"
                                                height="56"
                                                fill="white"
                                            />
                                        </clipPath>
                                    </defs>
                                </svg>

                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="41"
                                    height="56"
                                    viewBox="0 0 41 56"
                                    fill="none"
                                >
                                    <g clip-path="url(#clip0_77768_1819)">
                                        <path
                                            fill-rule="evenodd"
                                            clip-rule="evenodd"
                                            d="M4 0C1.79 0 0 1.79 0 4V52C0 54.21 1.79 56 4 56H36.52C38.73 56 40.52 54.21 40.52 52V12.53L27.69 0H4Z"
                                            fill="#2C946D"
                                        />
                                        <path
                                            d="M28.03 12.53C27.02 11.79 27.69 0 27.69 0L40.52 12.53C40.52 12.53 29.38 13.51 28.03 12.53Z"
                                            fill="#4FE4AB"
                                        />
                                        <path
                                            d="M19.35 44.46L20.79 47.01L22.25 44.46H23.64L21.6 47.73L23.66 51H22.27L20.8 48.55L19.33 51H17.93L19.97 47.73L17.96 44.46H19.36H19.35ZM29.86 46.05L28.71 46.25C28.66 46.1 28.59 45.96 28.48 45.83C28.38 45.7 28.24 45.59 28.06 45.5C27.88 45.41 27.66 45.37 27.4 45.37C27.04 45.37 26.74 45.45 26.5 45.61C26.26 45.77 26.14 45.98 26.14 46.23C26.14 46.45 26.22 46.62 26.38 46.76C26.54 46.89 26.8 47 27.16 47.09L28.2 47.33C28.8 47.47 29.25 47.68 29.55 47.97C29.85 48.26 29.99 48.64 29.99 49.1C29.99 49.49 29.88 49.84 29.65 50.15C29.43 50.45 29.11 50.69 28.71 50.87C28.31 51.04 27.84 51.13 27.32 51.13C26.59 51.13 25.99 50.97 25.53 50.66C25.07 50.34 24.78 49.9 24.68 49.32L25.91 49.13C25.99 49.45 26.14 49.69 26.38 49.86C26.62 50.02 26.93 50.1 27.31 50.1C27.73 50.1 28.06 50.01 28.31 49.84C28.56 49.66 28.69 49.45 28.69 49.2C28.69 49 28.61 48.82 28.46 48.68C28.31 48.54 28.08 48.44 27.77 48.36L26.66 48.12C26.05 47.98 25.6 47.76 25.3 47.46C25.01 47.16 24.87 46.77 24.87 46.31C24.87 45.92 24.98 45.59 25.19 45.3C25.41 45.01 25.7 44.78 26.08 44.62C26.46 44.46 26.9 44.37 27.39 44.37C28.1 44.37 28.65 44.52 29.06 44.83C29.47 45.13 29.73 45.54 29.87 46.05H29.86ZM32.66 42.27V51H31.39V42.27H32.66Z"
                                            fill="white"
                                        />
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_77768_1819">
                                            <rect
                                                width="40.52"
                                                height="56"
                                                fill="white"
                                            />
                                        </clipPath>
                                    </defs>
                                </svg>

                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="41"
                                    height="56"
                                    viewBox="0 0 41 56"
                                    fill="none"
                                >
                                    <g clip-path="url(#clip0_77768_1823)">
                                        <path
                                            fill-rule="evenodd"
                                            clip-rule="evenodd"
                                            d="M4 0C1.79 0 0 1.79 0 4V52C0 54.21 1.79 56 4 56H36.52C38.73 56 40.52 54.21 40.52 52V12.53L27.69 0H4Z"
                                            fill="#1052A2"
                                        />
                                        <path
                                            d="M28.03 12.53C27.02 11.79 27.69 0 27.69 0L40.52 12.53C40.52 12.53 29.38 13.51 28.03 12.53Z"
                                            fill="#63A3F0"
                                        />
                                        <path
                                            d="M17.53 51.13C17 51.13 16.53 51 16.12 50.73C15.71 50.46 15.38 50.07 15.15 49.57C14.92 49.06 14.8 48.46 14.8 47.75C14.8 47.04 14.92 46.44 15.15 45.93C15.39 45.43 15.72 45.04 16.13 44.78C16.54 44.51 17.02 44.38 17.54 44.38C17.95 44.38 18.27 44.45 18.52 44.58C18.77 44.71 18.96 44.87 19.1 45.05C19.24 45.23 19.35 45.39 19.42 45.52H19.5V42.28H20.77V51.01H19.53V49.99H19.42C19.34 50.13 19.23 50.29 19.09 50.47C18.95 50.65 18.75 50.81 18.5 50.94C18.25 51.07 17.93 51.14 17.53 51.14V51.13ZM17.81 50.04C18.18 50.04 18.49 49.94 18.74 49.75C19 49.55 19.19 49.28 19.32 48.94C19.45 48.59 19.52 48.19 19.52 47.73C19.52 47.27 19.45 46.88 19.32 46.54C19.19 46.2 19 45.93 18.74 45.74C18.49 45.55 18.17 45.45 17.8 45.45C17.43 45.45 17.1 45.55 16.84 45.75C16.58 45.95 16.39 46.22 16.26 46.56C16.13 46.9 16.07 47.29 16.07 47.72C16.07 48.15 16.14 48.55 16.27 48.9C16.4 49.25 16.59 49.53 16.85 49.73C17.11 49.93 17.43 50.03 17.8 50.03L17.81 50.04ZM25.35 51.13C24.74 51.13 24.2 50.99 23.74 50.71C23.28 50.43 22.93 50.04 22.67 49.53C22.42 49.02 22.29 48.43 22.29 47.76C22.29 47.09 22.42 46.49 22.67 45.98C22.92 45.47 23.28 45.08 23.74 44.8C24.2 44.52 24.73 44.38 25.35 44.38C25.97 44.38 26.5 44.52 26.96 44.8C27.42 45.08 27.77 45.48 28.03 45.98C28.28 46.49 28.41 47.08 28.41 47.76C28.41 48.44 28.28 49.03 28.03 49.53C27.78 50.04 27.42 50.43 26.96 50.71C26.5 50.99 25.97 51.13 25.35 51.13ZM25.35 50.06C25.75 50.06 26.08 49.95 26.34 49.74C26.6 49.53 26.79 49.25 26.92 48.9C27.05 48.55 27.11 48.17 27.11 47.75C27.11 47.33 27.05 46.95 26.92 46.6C26.8 46.25 26.6 45.97 26.34 45.75C26.08 45.54 25.75 45.43 25.35 45.43C24.95 45.43 24.62 45.54 24.35 45.75C24.09 45.96 23.89 46.25 23.77 46.6C23.65 46.95 23.58 47.33 23.58 47.75C23.58 48.17 23.64 48.56 23.77 48.9C23.9 49.25 24.09 49.53 24.35 49.74C24.61 49.95 24.95 50.06 25.35 50.06ZM32.58 51.13C31.95 51.13 31.4 50.99 30.94 50.7C30.49 50.41 30.14 50.01 29.89 49.5C29.65 48.99 29.52 48.41 29.52 47.75C29.52 47.09 29.64 46.5 29.9 45.99C30.15 45.48 30.5 45.08 30.96 44.79C31.41 44.5 31.95 44.36 32.57 44.36C33.07 44.36 33.51 44.45 33.9 44.64C34.29 44.82 34.6 45.08 34.84 45.41C35.08 45.74 35.22 46.12 35.27 46.56H34.03C33.96 46.25 33.81 45.99 33.56 45.77C33.32 45.55 32.99 45.44 32.59 45.44C32.23 45.44 31.92 45.53 31.66 45.72C31.4 45.9 31.19 46.17 31.04 46.51C30.89 46.85 30.82 47.25 30.82 47.72C30.82 48.19 30.89 48.61 31.04 48.96C31.18 49.31 31.39 49.57 31.65 49.77C31.92 49.96 32.23 50.06 32.59 50.06C32.83 50.06 33.05 50.02 33.25 49.93C33.45 49.84 33.62 49.71 33.75 49.54C33.89 49.37 33.98 49.17 34.04 48.93H35.28C35.23 49.35 35.1 49.73 34.87 50.06C34.64 50.39 34.33 50.65 33.95 50.84C33.57 51.03 33.12 51.13 32.6 51.13H32.58Z"
                                            fill="#EDEDFF"
                                        />
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_77768_1823">
                                            <rect
                                                width="40.52"
                                                height="56"
                                                fill="white"
                                            />
                                        </clipPath>
                                    </defs>
                                </svg>

                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="41"
                                    height="56"
                                    viewBox="0 0 41 56"
                                    fill="none"
                                >
                                    <g clip-path="url(#clip0_77768_1827)">
                                        <path
                                            fill-rule="evenodd"
                                            clip-rule="evenodd"
                                            d="M4 0C1.79 0 0 1.79 0 4V52C0 54.21 1.79 56 4 56H36.52C38.73 56 40.52 54.21 40.52 52V12.53L27.69 0H4Z"
                                            fill="#F12D0F"
                                        />
                                        <path
                                            d="M28.03 12.53C27.02 11.79 27.69 0 27.69 0L40.52 12.53C40.52 12.53 29.38 13.51 28.03 12.53Z"
                                            fill="#FF8585"
                                        />
                                        <path
                                            d="M29.24 45.93C29.01 45.42 28.68 45.04 28.27 44.77C27.85 44.51 27.38 44.37 26.85 44.37C26.45 44.37 26.12 44.44 25.87 44.58C25.63 44.71 25.43 44.87 25.29 45.05C25.16 45.22 25.05 45.38 24.98 45.52H24.87V44.46H23.62V53.46H24.9V49.98H24.98C25.05 50.12 25.16 50.28 25.3 50.46C25.45 50.64 25.64 50.8 25.89 50.93C26.14 51.06 26.47 51.13 26.87 51.13C27.4 51.13 27.87 51 28.28 50.73C28.69 50.45 29.01 50.07 29.25 49.56C29.48 49.06 29.6 48.45 29.6 47.74C29.6 47.03 29.48 46.43 29.24 45.93ZM28.12 48.91C27.98 49.26 27.79 49.54 27.54 49.74C27.28 49.94 26.96 50.04 26.58 50.04C26.22 50.04 25.91 49.95 25.65 49.75C25.4 49.56 25.21 49.29 25.07 48.94C24.94 48.59 24.87 48.19 24.87 47.73C24.87 47.27 24.94 46.88 25.07 46.54C25.2 46.2 25.39 45.93 25.64 45.74C25.9 45.55 26.21 45.45 26.58 45.45C26.97 45.45 27.28 45.55 27.54 45.75C27.8 45.95 27.99 46.22 28.12 46.57C28.25 46.91 28.32 47.3 28.32 47.73C28.32 48.16 28.25 48.56 28.12 48.91ZM21.84 45.93C21.6 45.42 21.28 45.04 20.86 44.77C20.45 44.51 19.98 44.37 19.45 44.37C19.04 44.37 18.72 44.44 18.47 44.58C18.22 44.71 18.03 44.87 17.89 45.05C17.75 45.22 17.64 45.38 17.57 45.52H17.46V44.46H16.22V53.46H17.49V49.98H17.57C17.65 50.12 17.75 50.28 17.9 50.46C18.04 50.64 18.23 50.8 18.48 50.93C18.74 51.06 19.06 51.13 19.46 51.13C19.99 51.13 20.46 51 20.87 50.73C21.28 50.45 21.61 50.07 21.84 49.56C22.08 49.06 22.2 48.45 22.2 47.74C22.2 47.03 22.08 46.43 21.84 45.93ZM20.71 48.91C20.58 49.26 20.39 49.54 20.13 49.74C19.87 49.94 19.56 50.04 19.18 50.04C18.8 50.04 18.5 49.95 18.25 49.75C17.99 49.56 17.8 49.29 17.67 48.94C17.53 48.59 17.47 48.19 17.47 47.73C17.47 47.27 17.53 46.88 17.66 46.54C17.79 46.2 17.98 45.93 18.24 45.74C18.49 45.55 18.81 45.45 19.18 45.45C19.55 45.45 19.88 45.55 20.13 45.75C20.39 45.95 20.59 46.22 20.71 46.57C20.84 46.91 20.91 47.3 20.91 47.73C20.91 48.16 20.84 48.56 20.71 48.91Z"
                                            fill="white"
                                        />
                                        <path
                                            d="M34.21 50.95C34.13 50.98 34.03 51.01 33.89 51.04C33.75 51.07 33.58 51.09 33.38 51.09C33.04 51.09 32.73 51.03 32.44 50.91C32.15 50.78 31.92 50.59 31.74 50.33C31.56 50.07 31.47 49.74 31.47 49.35V45.48H30.51V44.46H31.47V42.89H32.74V44.46H34.09V45.48H32.74V49.08C32.74 49.33 32.78 49.51 32.85 49.64C32.93 49.76 33.02 49.85 33.14 49.89C33.26 49.93 33.39 49.95 33.53 49.95C33.63 49.95 33.72 49.95 33.8 49.93C33.87 49.92 33.93 49.91 33.97 49.9L34.21 50.95Z"
                                            fill="white"
                                        />
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_77768_1827">
                                            <rect
                                                width="40.52"
                                                height="56"
                                                fill="white"
                                            />
                                        </clipPath>
                                    </defs>
                                </svg>

                                <div className="box-container">
                                    <div
                                        className="box"
                                        style={{ backgroundColor: '#1366FF' }}
                                    >
                                        <div
                                            onClick={e => getSCSSValue(e)}
                                            className="box-text"
                                        >{`ing-color-primary`}</div>
                                    </div>

                                    <div
                                        className="box"
                                        style={{ backgroundColor: '#B9D2FF' }}
                                    >
                                        <div
                                            onClick={e => getSCSSValue(e)}
                                            className="box-text"
                                        >{`ing-color-primary-med`}</div>
                                    </div>

                                    <div
                                        className="box"
                                        style={{ backgroundColor: '#E2EBFC' }}
                                    >
                                        <div
                                            onClick={e => getSCSSValue(e)}
                                            className="box-text"
                                        >{`ing-color-primary-lt`}</div>
                                    </div>
                                </div>
                            </div>
                            <br />
                            <div id="accent">
                                <h2 className="iNGAGED-Typography-Heading3">
                                    <span className="bold-text">
                                        Accent Colors
                                    </span>
                                </h2>
                                <h2 className="iNGAGED-Typography-Heading5">
                                    The Accent color pallet is used sparingly in
                                    support of the Primary pallet such as
                                    gradients and graphs.
                                </h2>
                                <hr />
                                <div className="box-container">
                                    <div
                                        className="box"
                                        style={{ backgroundColor: '#17BDBF' }}
                                    >
                                        <div
                                            onClick={e => getSCSSValue(e)}
                                            className="box-text"
                                        >{`ing-color-accent-green`}</div>
                                    </div>

                                    <div
                                        className="box"
                                        style={{ backgroundColor: '#F9B77B' }}
                                    >
                                        <div
                                            onClick={e => getSCSSValue(e)}
                                            className="box-text"
                                        >{`ing-color-accent-orange`}</div>
                                    </div>

                                    <div
                                        className="box"
                                        style={{ backgroundColor: '#9391FC' }}
                                    >
                                        <div
                                            onClick={e => getSCSSValue(e)}
                                            className="box-text"
                                        >{`ing-color-accent-purple`}</div>
                                    </div>
                                </div>
                            </div>
                            <br />
                            <div id="warning">
                                <h2 className="iNGAGED-Typography-Heading3">
                                    <span className="bold-text">Warning</span>
                                </h2>
                                <h2 className="iNGAGED-Typography-Heading5">
                                    These colors are used to convey caution used
                                    in pop ups and tags.
                                </h2>
                                <hr />

                                <div className="box-container">
                                    <div
                                        className="box"
                                        style={{ backgroundColor: '#FFA800' }}
                                    >
                                        <div
                                            onClick={e => getSCSSValue(e)}
                                            className="box-text"
                                        >{`ing-color-warning-drk`}</div>
                                    </div>

                                    <div
                                        className="box"
                                        style={{ backgroundColor: '#FEF3D8' }}
                                    >
                                        <div
                                            onClick={e => getSCSSValue(e)}
                                            className="box-text"
                                        >{`ing-color-warning-lt`}</div>
                                    </div>
                                </div>
                            </div>
                            <div id="information-select">
                                <br />
                                <h2 className="iNGAGED-Typography-Heading3">
                                    <span className="bold-text">
                                        Information / Select
                                    </span>
                                </h2>
                                <h2 className="iNGAGED-Typography-Heading5">
                                    These colors convey active state and
                                    information. The are to be used in info
                                    icons, menu highlights, selected menus.
                                </h2>
                                <hr />

                                <div className="box-container">
                                    <div
                                        className="box"
                                        style={{ backgroundColor: '#1366FF' }}
                                    >
                                        <div
                                            onClick={e => getSCSSValue(e)}
                                            className="box-text"
                                        >{`ing-color-info-drk`}</div>
                                    </div>

                                    <div
                                        className="box"
                                        style={{ backgroundColor: '#B9D2FF' }}
                                    >
                                        <div
                                            onClick={e => getSCSSValue(e)}
                                            className="box-text"
                                        >{`ing-color-info-med`}</div>
                                    </div>

                                    <div
                                        className="box"
                                        style={{ backgroundColor: '#E2EBFC' }}
                                    >
                                        <div
                                            onClick={e => getSCSSValue(e)}
                                            className="box-text"
                                        >{`ing-color-info-lt`}</div>
                                    </div>
                                </div>
                            </div>
                            <div id="destructive-required">
                                <br />
                                <h2 className="iNGAGED-Typography-Heading3">
                                    <span className="bold-text">
                                        Destructive / Required
                                    </span>
                                </h2>
                                <h2 className="iNGAGED-Typography-Heading5">
                                    These colors are used to convey negativity
                                    or incompleteness, used in error messages,
                                    badges, etc.
                                </h2>
                                <hr />

                                <div className="box-container">
                                    <div
                                        className="box"
                                        style={{ backgroundColor: '#EF4E45' }}
                                    >
                                        <div
                                            onClick={e => getSCSSValue(e)}
                                            className="box-text"
                                        >{`ing-color-destructive-drk`}</div>
                                    </div>

                                    <div
                                        className="box"
                                        style={{ backgroundColor: '#FCDCDC' }}
                                    >
                                        <div
                                            onClick={e => getSCSSValue(e)}
                                            className="box-text"
                                        >{`ing-color-destructive-lt`}</div>
                                    </div>
                                </div>
                            </div>
                            <div id="success">
                                <br />
                                <h2 className="iNGAGED-Typography-Heading3">
                                    <span className="bold-text">Success</span>
                                </h2>
                                <h2 className="iNGAGED-Typography-Heading5">
                                    These colors convey an emotion of positivity
                                    and are generally used accross success
                                    states.
                                </h2>
                                <hr />

                                <div className="box-container">
                                    {/* <div className="box" style={{ backgroundColor: '#53B483' }}>
                    <div onClick={(e) => getSCSSValue(e)} className="box-text">{`var(--iNGAGED-Success-Color);`}</div>
                  </div> */}

                                    <div
                                        className="box"
                                        style={{ backgroundColor: '#14BA6D' }}
                                    >
                                        <div
                                            onClick={e => getSCSSValue(e)}
                                            className="box-text"
                                        >{`ing-color-success-drk`}</div>
                                    </div>

                                    <div
                                        className="box"
                                        style={{ backgroundColor: '#ECFDF3' }}
                                    >
                                        <div
                                            conClick={e => getSCSSValue(e)}
                                            className="box-text"
                                        >{`ing-color-success-lt`}</div>
                                    </div>
                                </div>
                            </div>
                            <div id="neutrals">
                                <br />
                                <h2 className="iNGAGED-Typography-Heading3">
                                    <span className="bold-text">Neutrals</span>
                                </h2>
                                <h2 className="iNGAGED-Typography-Heading5">
                                    These colors convey an emotion of positivity
                                    and are generally used accross success
                                    states. The first color is used for Header
                                    and Menu text. The second color is used for
                                    Body and Sub text. The third color is for
                                    Sub Menu + Captions. The fourth color is for
                                    Disabled State, commonly seen on dropdowns.
                                    The fifth and sixth colors are used for Base
                                    Fill/Base Fill2. The final color is #FFF,
                                    commonly used for backgrounds of elements.
                                </h2>
                                <hr />

                                <div className="box-container">
                                    <div
                                        className="box"
                                        style={{ backgroundColor: '#2F2B43' }}
                                    >
                                        <div
                                            onClick={e => getSCSSValue(e)}
                                            className="box-text"
                                        >{`ing-color-neutral-6`}</div>
                                    </div>

                                    <div
                                        className="box"
                                        style={{ backgroundColor: '#667085' }}
                                    >
                                        <div
                                            onClick={e => getSCSSValue(e)}
                                            className="box-text"
                                        >{`ing-color-neutral-5`}</div>
                                    </div>

                                    <div
                                        className="box"
                                        style={{
                                            backgroundColor:
                                                'rgba(47, 43, 67, 0.6)',
                                        }}
                                    >
                                        <div
                                            onClick={e => getSCSSValue(e)}
                                            className="box-text"
                                        >{`ing-color-neutral-4`}</div>
                                    </div>

                                    <div
                                        className="box"
                                        style={{ backgroundColor: '#EAECF0' }}
                                    >
                                        <div
                                            onClick={e => getSCSSValue(e)}
                                            className="box-text"
                                        >{`ing-color-neutral-3`}</div>
                                    </div>

                                    <div
                                        className="box"
                                        style={{ backgroundColor: '#F5F7FA' }}
                                    >
                                        <div
                                            onClick={e => getSCSSValue(e)}
                                            className="box-text"
                                        >{`ing-color-neutral-2`}</div>
                                    </div>
                                </div>
                            </div>
                            {/* Neutrals continued */}
                            <div>
                                {/* Add three boxes, horizontal to each other */}
                                <div className="box-container">
                                    <div
                                        className="box"
                                        style={{ backgroundColor: '#F8FAFC' }}
                                    >
                                        <div
                                            onClick={e => getSCSSValue(e)}
                                            className="box-text"
                                        >{`ing-color-neutral-1`}</div>
                                    </div>

                                    <div
                                        className="box"
                                        style={{ backgroundColor: '#FFFFFF' }}
                                    >
                                        <div
                                            onClick={e => getSCSSValue(e)}
                                            className="box-text"
                                        >{`ing-color-neutral-0`}</div>
                                    </div>
                                </div>
                            </div>
                            <div id="gradient">
                                {/* Content for the "Primary" color section */}
                                <br />
                                <h2 className="iNGAGED-Typography-Heading3">
                                    <span className="bold-text">Gradient</span>
                                </h2>
                                <hr />

                                {/* Add three boxes, horizontal to each other */}
                                <div className="box-container">
                                    <div className="box-container">
                                        <div
                                            className="box-long"
                                            style={{
                                                backgroundImage:
                                                    'linear-gradient(45deg, #1366FF, #17BDBF)',
                                            }}
                                        >
                                            <div
                                                onClick={e => getSCSSValue(e)}
                                                className="box-text"
                                            >{`ing-color-gradient-blue-green`}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div id="display">
                                {/* Content for the Typography section */}
                                <hr />
                                <h2 className="iNGAGED-Typography-Heading1 iNGAGED-Primary-Color">
                                    <span className="bold-text">
                                        | Typography
                                    </span>
                                </h2>
                                <br />

                                <h2 className="iNGAGED-Typography-Heading4">
                                    {' '}
                                    <span className="bold-text">
                                        UX Guidelines
                                    </span>
                                </h2>
                                <h2 className="iNGAGED-Typography-Heading5">
                                    Typography in the iNGAGED Official Deisgn
                                    Style Guide is Left-Aligned text in
                                    elementst they appear in. Note the use case
                                    above each element.
                                </h2>

                                <br />

                                <div>
                                    <h2 className="iNGAGED-Typography-Heading5">
                                        {' '}
                                        Landing Page, Marketing
                                    </h2>
                                    <div className="box-container">
                                        <div className="box-container">
                                            <div
                                                className="box-skinny"
                                                style={{
                                                    backgroundColor: '#dfe6e9',
                                                }}
                                            >
                                                <div className="iNGAGED-Typography-Display1">{`Display1`}</div>
                                                <div
                                                    onClick={e =>
                                                        getSCSSValue(e)
                                                    }
                                                    className="box-text"
                                                >{`ing-text-display1`}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div>
                                    <h2 className="iNGAGED-Typography-Heading5">
                                        {' '}
                                        Landing Page, Marketing
                                    </h2>
                                    <div className="box-container">
                                        <div className="box-container">
                                            <div
                                                className="box-skinny"
                                                style={{
                                                    backgroundColor: '#dfe6e9',
                                                }}
                                            >
                                                <div className="iNGAGED-Typography-Display2">{`Display2`}</div>
                                                <div
                                                    onClick={e =>
                                                        getSCSSValue(e)
                                                    }
                                                    className="box-text"
                                                >{`ing-text-display2`}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div id="heading">
                                <div>
                                    <h2 className="iNGAGED-Typography-Heading5">
                                        {' '}
                                        Decimal Amounts - Dashboard Display
                                    </h2>
                                    <div className="box-container">
                                        <div className="box-container">
                                            <div
                                                className="box-skinny"
                                                style={{
                                                    backgroundColor: '#dfe6e9',
                                                }}
                                            >
                                                <div className="iNGAGED-Typography-Heading1">{`Heading1`}</div>
                                                <div
                                                    onClick={e =>
                                                        getSCSSValue(e)
                                                    }
                                                    className="box-text"
                                                >{`ing-text-heading1`}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div>
                                    <h2 className="iNGAGED-Typography-Heading5">
                                        Page Titles
                                    </h2>
                                    <div className="box-container">
                                        <div className="box-container">
                                            <div
                                                className="box-skinny"
                                                style={{
                                                    backgroundColor: '#dfe6e9',
                                                }}
                                            >
                                                <div className="iNGAGED-Typography-Heading2">{`Heading2`}</div>
                                                <div
                                                    onClick={e =>
                                                        getSCSSValue(e)
                                                    }
                                                    className="box-text"
                                                >{`ing-text-heading2`}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div>
                                    <h2 className="iNGAGED-Typography-Heading5">
                                        {' '}
                                        Dashboard Container Headers
                                    </h2>
                                    <div className="box-container">
                                        <div className="box-container">
                                            <div
                                                className="box-skinny"
                                                style={{
                                                    backgroundColor: '#dfe6e9',
                                                }}
                                            >
                                                <div className="iNGAGED-Typography-Heading3">{`Heading3`}</div>
                                                <div
                                                    onClick={e =>
                                                        getSCSSValue(e)
                                                    }
                                                    className="box-text"
                                                >{`ing-text-heading3`}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div>
                                    <h2 className="iNGAGED-Typography-Heading5">
                                        List Column Titles, Tabs, Breadcrumbs,
                                        Page Divider titles
                                    </h2>
                                    <div className="box-container">
                                        <div className="box-container">
                                            <div
                                                className="box-skinny"
                                                style={{
                                                    backgroundColor: '#dfe6e9',
                                                }}
                                            >
                                                <div className="iNGAGED-Typography-Heading4">{`Heading4`}</div>
                                                <div
                                                    onClick={e =>
                                                        getSCSSValue(e)
                                                    }
                                                    className="box-text"
                                                >{`ing-text-heading4`}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div>
                                    <h2 className="iNGAGED-Typography-Heading5">
                                        Container headers (sm)
                                    </h2>
                                    <div className="box-container">
                                        <div className="box-container">
                                            <div
                                                className="box-skinny"
                                                style={{
                                                    backgroundColor: '#dfe6e9',
                                                }}
                                            >
                                                <div className="iNGAGED-Typography-Heading5">{`Heading5`}</div>
                                                <div
                                                    onClick={e =>
                                                        getSCSSValue(e)
                                                    }
                                                    className="box-text"
                                                >{`ing-text-heading5`}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div>
                                    <h2 className="iNGAGED-Typography-Heading5">
                                        List Row Names
                                    </h2>
                                    <div className="box-container">
                                        <div className="box-container">
                                            <div
                                                className="box-skinny"
                                                style={{
                                                    backgroundColor: '#dfe6e9',
                                                }}
                                            >
                                                <div className="iNGAGED-Typography-Heading6">{`Heading6`}</div>
                                                <div
                                                    onClick={e =>
                                                        getSCSSValue(e)
                                                    }
                                                    className="box-text"
                                                >{`ing-text-heading6`}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div id="paragraph">
                                <h2 className="iNGAGED-Typography-Heading5">
                                    Avatar Initials
                                </h2>
                                <div className="row-container">
                                    <div className="box-container">
                                        <div className="box-container">
                                            <div
                                                className="box-skinny"
                                                style={{
                                                    backgroundColor: '#dfe6e9',
                                                }}
                                            >
                                                <div className="iNGAGED-Typography-Paragraph">{`Lead Paragraph`}</div>
                                                <div
                                                    onClick={e =>
                                                        getSCSSValue(e)
                                                    }
                                                    className="box-text"
                                                >{`ing-text-paragraph`}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div id="body">
                                <div>
                                    <div className="box-container">
                                        <div className="box-container">
                                            <div
                                                className="box-skinny"
                                                style={{
                                                    backgroundColor: '#dfe6e9',
                                                }}
                                            >
                                                <div className="iNGAGED-Typography-BodyLarge">{`Body Large`}</div>
                                                <div
                                                    onClick={e =>
                                                        getSCSSValue(e)
                                                    }
                                                    className="box-text"
                                                >{`ing-text-body-large`}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div>
                                    <div className="box-container">
                                        <div className="box-container">
                                            <div
                                                className="box-skinny"
                                                style={{
                                                    backgroundColor: '#dfe6e9',
                                                }}
                                            >
                                                <div className="iNGAGED-Typography-BodyMedium">{`Body Medium`}</div>
                                                <div
                                                    onClick={e =>
                                                        getSCSSValue(e)
                                                    }
                                                    className="box-text"
                                                >{`ing-text-body-medium`}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div>
                                    <div className="box-container">
                                        <div className="box-container">
                                            <div
                                                className="box-skinny"
                                                style={{
                                                    backgroundColor: '#dfe6e9',
                                                }}
                                            >
                                                <div className="iNGAGED-Typography-BodyNormal">{`Body Normal`}</div>
                                                <div
                                                    onClick={e =>
                                                        getSCSSValue(e)
                                                    }
                                                    className="box-text"
                                                >{`ing-text-body-normal`}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div>
                                    <div className="box-container">
                                        <div className="box-container">
                                            <div
                                                className="box-skinny"
                                                style={{
                                                    backgroundColor: '#dfe6e9',
                                                }}
                                            >
                                                <div className="iNGAGED-Typography-BodySmall">{`Body Small`}</div>
                                                <div
                                                    onClick={e =>
                                                        getSCSSValue(e)
                                                    }
                                                    className="box-text"
                                                >{`ing-text-body-small`}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div id="primaryaction">
                                {/* Content for the Buttons */}
                                <h2 className="iNGAGED-Typography-Heading1 iNGAGED-Primary-Color">
                                    <span className="bold-text">| Buttons</span>
                                </h2>
                                <br />
                                <h2 className="iNGAGED-Typography-Heading4">
                                    <span className="bold-text">
                                        UX Guidelines for Buttons
                                    </span>
                                </h2>
                                <h2 className="iNGAGED-Typography-Heading5">
                                    Interact with the buttons to see how they
                                    should behave. Primary Buttons and Pop-up
                                    Buttons have 'Unselected' and 'Active
                                    Select' states. In the 'Unselected' state
                                    the button is slighty larger, and when
                                    pressed its size shrinks slightly to
                                    indicate it being pressed.{' '}
                                </h2>

                                <br />
                                <h2 className="iNGAGED-Typography-Heading3">
                                    <span className="bold-text">
                                        Primary Action
                                    </span>
                                </h2>
                                <hr />

                                <div className="row-container">
                                    <div className="box-container">
                                        <div className="upload-file">
                                            <div className="button-container">
                                                <button
                                                    className="ing-button-primary-right"
                                                    type="submit"
                                                >
                                                    Right Icon{' '}
                                                    <i className="bi bi-chevron-right"></i>
                                                </button>
                                            </div>
                                            <div className="text-container">
                                                <div className="box-button">
                                                    <div className="custom-box">
                                                        <div className="left-section">
                                                            <p
                                                                onClick={e =>
                                                                    getSCSSValue(
                                                                        e,
                                                                    )
                                                                }
                                                                className="custom-text"
                                                            >
                                                                .ing-button-primary-right
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="box-container">
                                        <div className="upload-file">
                                            <div className="button-container">
                                                <button
                                                    className="ing-button-primary-left"
                                                    type="submit"
                                                >
                                                    <i className="bi bi-plus-lg"></i>
                                                    Left Icon
                                                </button>
                                            </div>
                                            <div className="text-container">
                                                <div className="box-button">
                                                    <div className="custom-box">
                                                        <div className="left-section">
                                                            <p
                                                                onClick={e =>
                                                                    getSCSSValue(
                                                                        e,
                                                                    )
                                                                }
                                                                className="custom-text"
                                                            >
                                                                .ing-button-primary-left
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="box-container">
                                        <div className="upload-file">
                                            <div className="button-container">
                                                <button
                                                    className="ing-button-primary-none"
                                                    type="submit"
                                                >
                                                    No Icon
                                                </button>
                                            </div>
                                            <div className="text-container">
                                                <div className="box-button">
                                                    <div className="custom-box">
                                                        <div className="left-section">
                                                            <p
                                                                onClick={e =>
                                                                    getSCSSValue(
                                                                        e,
                                                                    )
                                                                }
                                                                className="custom-text"
                                                            >
                                                                .ing-button-primary-none
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* BUTTONS: List BUTTONS SECTION */}
                            <div id="listbuttons">
                                <h2 className="iNGAGED-Typography-Heading3">
                                    <span className="bold-text">
                                        List Buttons
                                    </span>
                                </h2>
                                <hr />

                                <div className="row-container">
                                    {/* 1 */}
                                    <div>
                                        <div className="box-container">
                                            <div>
                                                <div className="box-container">
                                                    <div className="box-container">
                                                        <div className="float-end d-block align-items-center me-4">
                                                            <svg
                                                                xmlns="http://www.w3.org/2000/svg"
                                                                width="20"
                                                                height="20"
                                                                viewBox="0 0 20 20"
                                                                fill="none"
                                                            >
                                                                <path
                                                                    d="M0 10C0 15.5228 4.47715 20 10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10ZM7.37976 13.5041C7.13568 13.7482 6.73995 13.7482 6.49587 13.5041C6.2518 13.26 6.2518 12.8643 6.49587 12.6202L11.6161 7.49999L8.15646 7.49999C7.81128 7.49999 7.53146 7.22017 7.53146 6.87499C7.53146 6.52981 7.81128 6.24999 8.15646 6.24999L13.125 6.24999C13.4702 6.24999 13.75 6.52981 13.75 6.87499V11.8436C13.75 12.1888 13.4702 12.4686 13.125 12.4686C12.7798 12.4686 12.5 12.1888 12.5 11.8436L12.5 8.38387L7.37976 13.5041Z"
                                                                    fill="#1366FF"
                                                                />
                                                            </svg>

                                                            <div className="text-container">
                                                                <div className="box-button">
                                                                    <div className="custom-box">
                                                                        {/* <div className="left-section">
                                  <p onClick={(e) => getSCSSValue(e)} className="custom-text">.ing-text-buttons-ctas</p>
                                </div> */}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* 2 */}
                                    <div>
                                        <div className="box-container">
                                            <div>
                                                <div className="box-container">
                                                    <div className="box-container">
                                                        <div className="float-end d-block align-items-center me-4">
                                                            <svg
                                                                xmlns="http://www.w3.org/2000/svg"
                                                                width="20"
                                                                height="20"
                                                                viewBox="0 0 20 20"
                                                                fill="none"
                                                            >
                                                                <path
                                                                    d="M20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10ZM10.625 5.625C10.625 5.27982 10.3452 5 10 5C9.65482 5 9.375 5.27982 9.375 5.625V12.8661L6.69194 10.1831C6.44787 9.93898 6.05214 9.93898 5.80806 10.1831C5.56398 10.4271 5.56398 10.8229 5.80806 11.0669L9.55806 14.8169C9.80214 15.061 10.1979 15.061 10.4419 14.8169L14.1919 11.0669C14.436 10.8229 14.436 10.4271 14.1919 10.1831C13.9479 9.93898 13.5521 9.93898 13.3081 10.1831L10.625 12.8661V5.625Z"
                                                                    fill="#1366FF"
                                                                />
                                                            </svg>

                                                            <div className="text-container">
                                                                <div className="box-button">
                                                                    <div className="custom-box">
                                                                        {/* <div className="left-section">
                                  <p onClick={(e) => getSCSSValue(e)} className="custom-text">.ing-text-buttons-ctas</p>
                                </div> */}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* 3 */}

                                    <div>
                                        <div className="box-container">
                                            <div>
                                                <div className="box-container">
                                                    <div className="box-container">
                                                        <div className="float-end d-block align-items-center me-4">
                                                            <svg
                                                                xmlns="http://www.w3.org/2000/svg"
                                                                width="20"
                                                                height="20"
                                                                viewBox="0 0 20 20"
                                                                fill="none"
                                                            >
                                                                <path
                                                                    d="M0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10ZM9.375 14.375C9.375 14.7202 9.65482 15 10 15C10.3452 15 10.625 14.7202 10.625 14.375V7.13388L13.3081 9.81694C13.5521 10.061 13.9479 10.061 14.1919 9.81694C14.436 9.57286 14.436 9.17714 14.1919 8.93306L10.4419 5.18306C10.1979 4.93898 9.80214 4.93898 9.55806 5.18306L5.80806 8.93306C5.56398 9.17714 5.56398 9.57286 5.80806 9.81694C6.05214 10.061 6.44786 10.061 6.69194 9.81694L9.375 7.13388V14.375Z"
                                                                    fill="#1366FF"
                                                                />
                                                            </svg>

                                                            <div className="text-container">
                                                                <div className="box-button">
                                                                    <div className="custom-box">
                                                                        {/* <div className="left-section">
                                  <p onClick={(e) => getSCSSValue(e)} className="custom-text">.ing-text-buttons-ctas</p>
                                </div> */}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div>
                                        <div className="box-container">
                                            <div>
                                                <div className="box-container">
                                                    <div className="box-container">
                                                        <div className="float-end d-block align-items-center me-4">
                                                            <DownloadIcon />
                                                            <div className="text-container">
                                                                <div className="box-button">
                                                                    <div className="custom-box">
                                                                        {/* <div className="left-section">
                                  <p onClick={(e) => getSCSSValue(e)} className="custom-text">.ing-text-buttons-ctas</p>
                                </div> */}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* 7 */}
                                    <div>
                                        <div className="box-container">
                                            <div>
                                                <div className="box-container">
                                                    <div className="box-container">
                                                        <div className="float-end d-block align-items-center me-4">
                                                            <svg
                                                                width="20"
                                                                height="20"
                                                                viewBox="0 0 20 20"
                                                                fill="none"
                                                                xmlns="http://www.w3.org/2000/svg"
                                                            >
                                                                <circle
                                                                    cx="10"
                                                                    cy="10"
                                                                    r="10"
                                                                    fill="#1366FF"
                                                                />
                                                                <path
                                                                    d="M16 10C16 10 13.75 5.875 10 5.875C6.25 5.875 4 10 4 10C4 10 6.25 14.125 10 14.125C13.75 14.125 16 10 16 10ZM4.87952 10C4.92222 9.93491 4.97091 9.86258 5.02545 9.78431C5.27662 9.42395 5.64723 8.94468 6.12408 8.46783C7.09077 7.50114 8.41046 6.625 10 6.625C11.5895 6.625 12.9092 7.50114 13.8759 8.46783C14.3528 8.94468 14.7234 9.42395 14.9745 9.78431C15.0291 9.86258 15.0778 9.93491 15.1205 10C15.0778 10.0651 15.0291 10.1374 14.9745 10.2157C14.7234 10.5761 14.3528 11.0553 13.8759 11.5322C12.9092 12.4989 11.5895 13.375 10 13.375C8.41046 13.375 7.09077 12.4989 6.12408 11.5322C5.64723 11.0553 5.27662 10.5761 5.02545 10.2157C4.97091 10.1374 4.92222 10.0651 4.87952 10Z"
                                                                    fill="white"
                                                                />
                                                                <path
                                                                    d="M10 8.125C8.96447 8.125 8.125 8.96447 8.125 10C8.125 11.0355 8.96447 11.875 10 11.875C11.0355 11.875 11.875 11.0355 11.875 10C11.875 8.96447 11.0355 8.125 10 8.125ZM7.375 10C7.375 8.55025 8.55025 7.375 10 7.375C11.4497 7.375 12.625 8.55025 12.625 10C12.625 11.4497 11.4497 12.625 10 12.625C8.55025 12.625 7.375 11.4497 7.375 10Z"
                                                                    fill="white"
                                                                />
                                                            </svg>
                                                            <div className="text-container">
                                                                <div className="box-button">
                                                                    <div className="custom-box">
                                                                        {/* <div className="left-section">
                                  <p onClick={(e) => getSCSSValue(e)} className="custom-text">.ing-text-buttons-ctas</p>
                                </div> */}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div>
                                        <div className="box-container">
                                            <div>
                                                <div className="box-container">
                                                    <div className="box-container">
                                                        <div className="float-end d-block align-items-center me-4">
                                                            <svg
                                                                xmlns="http://www.w3.org/2000/svg"
                                                                width="20"
                                                                height="20"
                                                                viewBox="0 0 20 20"
                                                                fill="none"
                                                            >
                                                                <circle
                                                                    cx="10"
                                                                    cy="10"
                                                                    r="10"
                                                                    fill="#1366FF"
                                                                />
                                                                <line
                                                                    x1="6"
                                                                    y1="9.75"
                                                                    x2="14.0178"
                                                                    y2="9.75"
                                                                    stroke="white"
                                                                    stroke-width="0.5"
                                                                />
                                                                <line
                                                                    x1="6"
                                                                    y1="12.75"
                                                                    x2="14.0178"
                                                                    y2="12.75"
                                                                    stroke="white"
                                                                    stroke-width="0.5"
                                                                />
                                                                <line
                                                                    x1="6"
                                                                    y1="6.75"
                                                                    x2="14.0178"
                                                                    y2="6.75"
                                                                    stroke="white"
                                                                    stroke-width="0.5"
                                                                />
                                                            </svg>
                                                            <div className="text-container">
                                                                <div className="box-button">
                                                                    <div className="custom-box">
                                                                        {/* <div className="left-section">
                                  <p onClick={(e) => getSCSSValue(e)} className="custom-text">.ing-text-buttons-ctas</p>
                                </div> */}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* 4 */}
                                    <div>
                                        <div className="box-container">
                                            <div>
                                                <div className="box-container">
                                                    <div className="box-container">
                                                        <div className="float-end d-block align-items-center me-4">
                                                            <svg
                                                                xmlns="http://www.w3.org/2000/svg"
                                                                width="20"
                                                                height="20"
                                                                viewBox="0 0 20 20"
                                                                fill="none"
                                                            >
                                                                <circle
                                                                    cx="10"
                                                                    cy="10"
                                                                    r="9.5"
                                                                    stroke="#1366FF"
                                                                />
                                                                <line
                                                                    x1="6"
                                                                    y1="9.75"
                                                                    x2="14.0178"
                                                                    y2="9.75"
                                                                    stroke="#1366FF"
                                                                    stroke-width="0.5"
                                                                />
                                                                <line
                                                                    x1="6"
                                                                    y1="12.75"
                                                                    x2="14.0178"
                                                                    y2="12.75"
                                                                    stroke="#1366FF"
                                                                    stroke-width="0.5"
                                                                />
                                                                <line
                                                                    x1="6"
                                                                    y1="6.75"
                                                                    x2="14.0178"
                                                                    y2="6.75"
                                                                    stroke="#1366FF"
                                                                    stroke-width="0.5"
                                                                />
                                                            </svg>

                                                            <div className="text-container">
                                                                <div className="box-button">
                                                                    <div className="custom-box">
                                                                        {/* <div className="left-section">
                                  <p onClick={(e) => getSCSSValue(e)} className="custom-text">.ing-text-buttons-ctas</p>
                                </div> */}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* 5 */}

                                    {/* 9 */}
                                    <div>
                                        <div className="box-container">
                                            <div>
                                                <div className="box-container">
                                                    <div className="box-container">
                                                        <div className="float-end d-block align-items-center me-4">
                                                            <svg
                                                                width="20"
                                                                height="20"
                                                                viewBox="0 0 20 20"
                                                                fill="none"
                                                                xmlns="http://www.w3.org/2000/svg"
                                                            >
                                                                <circle
                                                                    cx="10"
                                                                    cy="10"
                                                                    r="10"
                                                                    fill="#1366FF"
                                                                />
                                                                <path
                                                                    d="M5.93732 15.0164C5.41965 15.0061 5.0083 14.5782 5.01855 14.0605L5.17929 5.93708C5.18954 5.41941 5.61749 5.00806 6.13516 5.01831L14.2586 5.17905C14.7762 5.1893 15.1876 5.61725 15.1773 6.13492L15.0166 14.2583C15.0063 14.776 14.5784 15.1873 14.0607 15.1771L5.93732 15.0164ZM5.64343 14.0729C5.64001 14.2454 5.77713 14.3881 5.94968 14.3915L14.0731 14.5522C14.2456 14.5556 14.3883 14.4185 14.3917 14.246L14.435 12.0589L5.6867 11.8858L5.64343 14.0729ZM14.4968 8.9345L5.74853 8.76139L5.69907 11.2609L14.4474 11.434L14.4968 8.9345ZM14.5092 8.30962L14.5525 6.12255C14.5559 5.95 14.4188 5.80735 14.2462 5.80393L6.12279 5.64319C5.95024 5.63977 5.80758 5.77689 5.80417 5.94944L5.76089 8.13651L14.5092 8.30962Z"
                                                                    fill="white"
                                                                />
                                                            </svg>
                                                            <div className="text-container">
                                                                <div className="box-button">
                                                                    <div className="custom-box">
                                                                        {/* <div className="left-section">
                                  <p onClick={(e) => getSCSSValue(e)} className="custom-text">.ing-text-buttons-ctas</p>
                                </div> */}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* 11 */}
                                    <div>
                                        <div className="box-container">
                                            <div>
                                                <div className="box-container">
                                                    <div className="box-container">
                                                        <div className="float-end d-block align-items-center me-4">
                                                            <svg
                                                                width="20"
                                                                height="20"
                                                                viewBox="0 0 20 20"
                                                                fill="none"
                                                                xmlns="http://www.w3.org/2000/svg"
                                                            >
                                                                <circle
                                                                    cx="10"
                                                                    cy="10"
                                                                    r="9.5"
                                                                    fill="white"
                                                                    stroke="#1366FF"
                                                                />
                                                                <rect
                                                                    width="12"
                                                                    height="12"
                                                                    transform="translate(4 15.9976) rotate(-88.8664)"
                                                                    fill="white"
                                                                />
                                                                <path
                                                                    d="M5.93732 15.0164C5.41965 15.0061 5.0083 14.5782 5.01855 14.0605L5.17929 5.93708C5.18954 5.41941 5.61749 5.00806 6.13516 5.01831L14.2586 5.17905C14.7762 5.1893 15.1876 5.61725 15.1773 6.13492L15.0166 14.2583C15.0063 14.776 14.5784 15.1873 14.0607 15.1771L5.93732 15.0164ZM5.64343 14.0729C5.64001 14.2454 5.77713 14.3881 5.94968 14.3915L14.0731 14.5522C14.2456 14.5556 14.3883 14.4185 14.3917 14.246L14.435 12.0589L5.6867 11.8858L5.64343 14.0729ZM14.4968 8.9345L5.74853 8.76139L5.69907 11.2609L14.4474 11.434L14.4968 8.9345ZM14.5092 8.30962L14.5525 6.12255C14.5559 5.95 14.4188 5.80735 14.2462 5.80393L6.12279 5.64319C5.95024 5.63977 5.80758 5.77689 5.80417 5.94944L5.76089 8.13651L14.5092 8.30962Z"
                                                                    fill="#1366FF"
                                                                />
                                                            </svg>
                                                            <div className="text-container">
                                                                <div className="box-button">
                                                                    <div className="custom-box">
                                                                        {/* <div className="left-section">
                                  <p onClick={(e) => getSCSSValue(e)} className="custom-text">.ing-text-buttons-ctas</p>
                                </div> */}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div>
                                        <div className="box-container">
                                            <div>
                                                <div className="box-container">
                                                    <div className="box-container">
                                                        <div className="float-end d-block align-items-center me-4">
                                                            <svg
                                                                width="20"
                                                                height="20"
                                                                viewBox="0 0 20 20"
                                                                fill="none"
                                                                xmlns="http://www.w3.org/2000/svg"
                                                            >
                                                                <circle
                                                                    cx="10"
                                                                    cy="10"
                                                                    r="10"
                                                                    fill="#1366FF"
                                                                />
                                                                <rect
                                                                    width="12"
                                                                    height="12"
                                                                    transform="translate(4 4)"
                                                                    fill="#1366FF"
                                                                />
                                                                <path
                                                                    d="M4.75 5.875C4.75 5.25368 5.25368 4.75 5.875 4.75L8.125 4.75C8.74632 4.75 9.25 5.25368 9.25 5.875V8.125C9.25 8.74632 8.74632 9.25 8.125 9.25H5.875C5.25368 9.25 4.75 8.74632 4.75 8.125L4.75 5.875ZM5.875 5.5C5.66789 5.5 5.5 5.66789 5.5 5.875V8.125C5.5 8.33211 5.66789 8.5 5.875 8.5H8.125C8.33211 8.5 8.5 8.33211 8.5 8.125V5.875C8.5 5.66789 8.33211 5.5 8.125 5.5H5.875ZM10.75 5.875C10.75 5.25368 11.2537 4.75 11.875 4.75L14.125 4.75C14.7463 4.75 15.25 5.25368 15.25 5.875V8.125C15.25 8.74632 14.7463 9.25 14.125 9.25H11.875C11.2537 9.25 10.75 8.74632 10.75 8.125V5.875ZM11.875 5.5C11.6679 5.5 11.5 5.66789 11.5 5.875V8.125C11.5 8.33211 11.6679 8.5 11.875 8.5H14.125C14.3321 8.5 14.5 8.33211 14.5 8.125V5.875C14.5 5.66789 14.3321 5.5 14.125 5.5H11.875ZM4.75 11.875C4.75 11.2537 5.25368 10.75 5.875 10.75H8.125C8.74632 10.75 9.25 11.2537 9.25 11.875V14.125C9.25 14.7463 8.74632 15.25 8.125 15.25H5.875C5.25368 15.25 4.75 14.7463 4.75 14.125L4.75 11.875ZM5.875 11.5C5.66789 11.5 5.5 11.6679 5.5 11.875V14.125C5.5 14.3321 5.66789 14.5 5.875 14.5H8.125C8.33211 14.5 8.5 14.3321 8.5 14.125V11.875C8.5 11.6679 8.33211 11.5 8.125 11.5H5.875ZM10.75 11.875C10.75 11.2537 11.2537 10.75 11.875 10.75H14.125C14.7463 10.75 15.25 11.2537 15.25 11.875V14.125C15.25 14.7463 14.7463 15.25 14.125 15.25H11.875C11.2537 15.25 10.75 14.7463 10.75 14.125V11.875ZM11.875 11.5C11.6679 11.5 11.5 11.6679 11.5 11.875V14.125C11.5 14.3321 11.6679 14.5 11.875 14.5H14.125C14.3321 14.5 14.5 14.3321 14.5 14.125V11.875C14.5 11.6679 14.3321 11.5 14.125 11.5H11.875Z"
                                                                    fill="white"
                                                                />
                                                            </svg>
                                                            <div className="text-container">
                                                                <div className="box-button">
                                                                    <div className="custom-box">
                                                                        {/* <div className="left-section">
                                  <p onClick={(e) => getSCSSValue(e)} className="custom-text">.ing-text-buttons-ctas</p>
                                </div> */}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* 10 */}
                                    <div>
                                        <div className="box-container">
                                            <div>
                                                <div className="box-container">
                                                    <div className="box-container">
                                                        <div className="float-end d-block align-items-center me-4">
                                                            <svg
                                                                width="20"
                                                                height="20"
                                                                viewBox="0 0 20 20"
                                                                fill="none"
                                                                xmlns="http://www.w3.org/2000/svg"
                                                            >
                                                                <circle
                                                                    cx="10"
                                                                    cy="10"
                                                                    r="9.5"
                                                                    fill="white"
                                                                    stroke="#1366FF"
                                                                />
                                                                <rect
                                                                    width="12"
                                                                    height="12"
                                                                    transform="translate(4 4)"
                                                                    fill="white"
                                                                />
                                                                <path
                                                                    d="M4.75 5.875C4.75 5.25368 5.25368 4.75 5.875 4.75L8.125 4.75C8.74632 4.75 9.25 5.25368 9.25 5.875V8.125C9.25 8.74632 8.74632 9.25 8.125 9.25H5.875C5.25368 9.25 4.75 8.74632 4.75 8.125L4.75 5.875ZM5.875 5.5C5.66789 5.5 5.5 5.66789 5.5 5.875V8.125C5.5 8.33211 5.66789 8.5 5.875 8.5H8.125C8.33211 8.5 8.5 8.33211 8.5 8.125V5.875C8.5 5.66789 8.33211 5.5 8.125 5.5H5.875ZM10.75 5.875C10.75 5.25368 11.2537 4.75 11.875 4.75L14.125 4.75C14.7463 4.75 15.25 5.25368 15.25 5.875V8.125C15.25 8.74632 14.7463 9.25 14.125 9.25H11.875C11.2537 9.25 10.75 8.74632 10.75 8.125V5.875ZM11.875 5.5C11.6679 5.5 11.5 5.66789 11.5 5.875V8.125C11.5 8.33211 11.6679 8.5 11.875 8.5H14.125C14.3321 8.5 14.5 8.33211 14.5 8.125V5.875C14.5 5.66789 14.3321 5.5 14.125 5.5H11.875ZM4.75 11.875C4.75 11.2537 5.25368 10.75 5.875 10.75H8.125C8.74632 10.75 9.25 11.2537 9.25 11.875V14.125C9.25 14.7463 8.74632 15.25 8.125 15.25H5.875C5.25368 15.25 4.75 14.7463 4.75 14.125L4.75 11.875ZM5.875 11.5C5.66789 11.5 5.5 11.6679 5.5 11.875V14.125C5.5 14.3321 5.66789 14.5 5.875 14.5H8.125C8.33211 14.5 8.5 14.3321 8.5 14.125V11.875C8.5 11.6679 8.33211 11.5 8.125 11.5H5.875ZM10.75 11.875C10.75 11.2537 11.2537 10.75 11.875 10.75H14.125C14.7463 10.75 15.25 11.2537 15.25 11.875V14.125C15.25 14.7463 14.7463 15.25 14.125 15.25H11.875C11.2537 15.25 10.75 14.7463 10.75 14.125V11.875ZM11.875 11.5C11.6679 11.5 11.5 11.6679 11.5 11.875V14.125C11.5 14.3321 11.6679 14.5 11.875 14.5H14.125C14.3321 14.5 14.5 14.3321 14.5 14.125V11.875C14.5 11.6679 14.3321 11.5 14.125 11.5H11.875Z"
                                                                    fill="#1366FF"
                                                                />
                                                            </svg>
                                                            <div className="text-container">
                                                                <div className="box-button">
                                                                    <div className="custom-box">
                                                                        {/* <div className="left-section">
                                  <p onClick={(e) => getSCSSValue(e)} className="custom-text">.ing-text-buttons-ctas</p>
                                </div> */}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* 6 */}
                                    <div>
                                        <div className="box-container">
                                            <div>
                                                <div className="box-container">
                                                    <div className="box-container">
                                                        <div className="float-end d-block align-items-center me-4">
                                                            <svg
                                                                xmlns="http://www.w3.org/2000/svg"
                                                                width="16"
                                                                height="16"
                                                                viewBox="0 0 16 16"
                                                                fill="none"
                                                            >
                                                                <path
                                                                    d="M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM8.5 4.5C8.5 4.22386 8.27614 4 8 4C7.72386 4 7.5 4.22386 7.5 4.5V7.5H4.5C4.22386 7.5 4 7.72386 4 8C4 8.27614 4.22386 8.5 4.5 8.5H7.5V11.5C7.5 11.7761 7.72386 12 8 12C8.27614 12 8.5 11.7761 8.5 11.5V8.5H11.5C11.7761 8.5 12 8.27614 12 8C12 7.72386 11.7761 7.5 11.5 7.5H8.5V4.5Z"
                                                                    fill="#14BA6D"
                                                                />
                                                            </svg>

                                                            <div className="text-container">
                                                                <div className="box-button">
                                                                    <div className="custom-box">
                                                                        {/* <div className="left-section">
                                  <p onClick={(e) => getSCSSValue(e)} className="custom-text">.ing-text-buttons-ctas</p>
                                </div> */}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div id="textbuttons">
                                <h2 className="iNGAGED-Typography-Heading3">
                                    <span className="bold-text">
                                        Text Buttons
                                    </span>
                                </h2>
                                <hr />

                                <div className="row-container">
                                    <div>
                                        <div className="box-container">
                                            <div className="box-container">
                                                <div className="float-end d-block align-items-center me-4">
                                                    <p
                                                        type="button"
                                                        className="ing-text-buttons"
                                                    >
                                                        {' '}
                                                        <i className="bi bi-check-lg me-2" />{' '}
                                                        Save{' '}
                                                    </p>
                                                    <div className="text-container">
                                                        <div className="box-button">
                                                            <div className="custom-box">
                                                                <div className="left-section">
                                                                    <p
                                                                        onClick={e =>
                                                                            getSCSSValue(
                                                                                e,
                                                                            )
                                                                        }
                                                                        className="custom-text"
                                                                    >
                                                                        .ing-text-buttons-save
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div>
                                        <div className="box-container">
                                            <div className="box-container">
                                                <div className="float-end d-block align-items-center me-4">
                                                    <p
                                                        type="button"
                                                        className="ing-text-buttons"
                                                    >
                                                        {' '}
                                                        <i className="bi bi-x-lg me-2" />{' '}
                                                        Close{' '}
                                                    </p>
                                                    <div className="text-container">
                                                        <div className="box-button">
                                                            <div className="custom-box">
                                                                <div className="left-section">
                                                                    <p
                                                                        onClick={e =>
                                                                            getSCSSValue(
                                                                                e,
                                                                            )
                                                                        }
                                                                        className="custom-text"
                                                                    >
                                                                        .ing-text-buttons-close
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div>
                                        <div className="box-container">
                                            <div className="box-container">
                                                <div className="float-end d-block align-items-center me-4">
                                                    <p
                                                        type="button"
                                                        className="ing-text-buttons"
                                                    >
                                                        {' '}
                                                        <i className="bi bi-trash3 me-2" />{' '}
                                                        Delete{' '}
                                                    </p>
                                                    <div className="text-container">
                                                        <div className="box-button">
                                                            <div className="custom-box">
                                                                <div className="left-section">
                                                                    <p
                                                                        onClick={e =>
                                                                            getSCSSValue(
                                                                                e,
                                                                            )
                                                                        }
                                                                        className="custom-text"
                                                                    >
                                                                        .ing-text-buttons-delete
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div>
                                        <div className="box-container">
                                            <div className="box-container">
                                                <div className="float-end d-block align-items-center me-4">
                                                    <p
                                                        type="button"
                                                        className="ing-text-buttons"
                                                    >
                                                        {' '}
                                                        <i className="bi bi-copy me-2" />{' '}
                                                        Duplicate{' '}
                                                    </p>
                                                    <div className="text-container">
                                                        <div className="box-button">
                                                            <div className="custom-box">
                                                                <div className="left-section">
                                                                    <p
                                                                        onClick={e =>
                                                                            getSCSSValue(
                                                                                e,
                                                                            )
                                                                        }
                                                                        className="custom-text"
                                                                    >
                                                                        .ing-text-buttons-duplicate
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div>
                                        <div className="box-container">
                                            <div className="box-container">
                                                <div className="float-end d-block align-items-center me-4">
                                                    <p
                                                        type="button"
                                                        className="ing-text-buttons"
                                                    >
                                                        {' '}
                                                        <i className="bi bi-cloud-arrow-down" />{' '}
                                                        Longer Worded CTAs{' '}
                                                    </p>
                                                    <div className="text-container">
                                                        <div className="box-button">
                                                            <div className="custom-box">
                                                                <div className="left-section">
                                                                    <p
                                                                        onClick={e =>
                                                                            getSCSSValue(
                                                                                e,
                                                                            )
                                                                        }
                                                                        className="custom-text"
                                                                    >
                                                                        .ing-text-buttons-ctas
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div>
                                        <div className="box-container">
                                            <div className="box-container">
                                                <div className="float-end d-block align-items-center me-4">
                                                    {/* <p type="button" className="ing-text-buttons"> <i className="bi bi-cloud-arrow-down" /> Longer Worded CTAs </p> */}
                                                    <div className="text-container">
                                                        <div className="box-button">
                                                            <div className="custom-box">
                                                                {/* <div className="left-section">
                                  <p onClick={(e) => getSCSSValue(e)} className="custom-text">.ing-text-buttons-ctas</p>
                                </div> */}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div>
                                        <div className="box-container">
                                            <div className="box-container">
                                                <div className="float-end d-block align-items-center me-4">
                                                    {/* <p type="button" className="ing-text-buttons"> <i className="bi bi-cloud-arrow-down" /> Longer Worded CTAs </p> */}
                                                    <div className="text-container">
                                                        <div className="box-button">
                                                            <div className="custom-box">
                                                                {/* <div className="left-section">
                                  <p onClick={(e) => getSCSSValue(e)} className="custom-text">.ing-text-buttons-ctas</p>
                                </div> */}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* BUTTONS: POP UP BUTTONS SECTION */}
                            <div id="popUpButtons">
                                <h2 className="iNGAGED-Typography-Heading3">
                                    <span className="bold-text">
                                        Pop Up Buttons
                                    </span>
                                    <br />
                                    <br />

                                    <h2 className="iNGAGED-Typography-Heading5">
                                        Pop-up Buttons appear in commonly used
                                        'Popups - Action Required' elements. To
                                        see the Figma design,{' '}
                                        <a
                                            href="https://www.figma.com/file/sZkGn2dTLeyfzhXupoTbYY/Draft-Style-Guide---iNGAGED?node-id=73626%3A422&mode=dev"
                                            target="_blank"
                                            className="linked-text"
                                        >
                                            click here
                                        </a>
                                    </h2>
                                </h2>
                                <hr />
                                <div className="box-container">
                                    <div className="upload-file">
                                        <div className="button-container">
                                            <button
                                                className="ing-popup-yellow-negative submit-button-form"
                                                type="submit"
                                            >
                                                Negative
                                            </button>
                                        </div>
                                        <div className="text-container">
                                            <div className="box-button">
                                                <div className="custom-box">
                                                    <div className="left-section">
                                                        <p
                                                            onClick={e =>
                                                                getSCSSValue(e)
                                                            }
                                                            className="custom-text"
                                                        >
                                                            .ing-popup-yellow-negative
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="upload-file">
                                        <div className="button-container">
                                            <button
                                                className="ing-popup-yellow-positive submit-button-form"
                                                type="submit"
                                            >
                                                Positive
                                            </button>
                                        </div>
                                        <div className="text-container">
                                            <div className="box-button">
                                                <div className="custom-box">
                                                    <div className="left-section">
                                                        <p
                                                            onClick={e =>
                                                                getSCSSValue(e)
                                                            }
                                                            className="custom-text"
                                                        >
                                                            .ing-popup-yellow-positive
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="box-container">
                                    <div className="upload-file">
                                        <div className="button-container">
                                            <button
                                                className="ing-popup-green-negative submit-button-form"
                                                type="submit"
                                            >
                                                Negative
                                            </button>
                                        </div>
                                        <div className="text-container">
                                            <div className="box-button">
                                                <div className="custom-box">
                                                    <div className="left-section">
                                                        <p
                                                            onClick={e =>
                                                                getSCSSValue(e)
                                                            }
                                                            className="custom-text"
                                                        >
                                                            .ing-popup-green-negative
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="upload-file">
                                        <div className="button-container">
                                            <button
                                                className="ing-popup-green-positive submit-button-form"
                                                type="submit"
                                            >
                                                Positive
                                            </button>
                                        </div>
                                        <div className="text-container">
                                            <div className="box-button">
                                                <div className="custom-box">
                                                    <div className="left-section">
                                                        <p
                                                            onClick={e =>
                                                                getSCSSValue(e)
                                                            }
                                                            className="custom-text"
                                                        >
                                                            .ing-popup-green-positive
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="box-container">
                                    <div className="upload-file">
                                        <div className="button-container">
                                            <button
                                                className="ing-popup-blue-negative submit-button-form"
                                                type="submit"
                                            >
                                                Negative
                                            </button>
                                        </div>
                                        <div className="text-container">
                                            <div className="box-button">
                                                <div className="custom-box">
                                                    <div className="left-section">
                                                        <p
                                                            onClick={e =>
                                                                getSCSSValue(e)
                                                            }
                                                            className="custom-text"
                                                        >
                                                            .ing-popup-blue-negative
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="upload-file">
                                        <div className="button-container">
                                            <button
                                                className="ing-popup-blue-positive submit-button-form"
                                                type="submit"
                                            >
                                                Positive
                                            </button>
                                        </div>
                                        <div className="text-container">
                                            <div className="box-button">
                                                <div className="custom-box">
                                                    <div className="left-section2">
                                                        <p
                                                            onClick={e =>
                                                                getSCSSValue(e)
                                                            }
                                                            className="custom-text"
                                                        >
                                                            .ing-popup-blue-positive
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="box-container">
                                    <div className="upload-file">
                                        <div className="button-container">
                                            <button
                                                className="ing-popup-red-negative submit-button-form"
                                                type="submit"
                                            >
                                                Negative
                                            </button>
                                        </div>
                                        <div className="text-container">
                                            <div className="box-button">
                                                <div className="custom-box">
                                                    <div className="left-section">
                                                        <p
                                                            onClick={e =>
                                                                getSCSSValue(e)
                                                            }
                                                            className="custom-text"
                                                        >
                                                            .ing-popup-red-negative
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="upload-file">
                                        <div className="button-container">
                                            <button
                                                className="ing-popup-red-positive submit-button-form"
                                                type="submit"
                                            >
                                                Positive
                                            </button>
                                        </div>
                                        <div className="text-container">
                                            <div className="box-button">
                                                <div className="custom-box">
                                                    <div className="left-section3">
                                                        <p
                                                            onClick={e =>
                                                                getSCSSValue(e)
                                                            }
                                                            className="custom-text"
                                                        >
                                                            .ing-popup-red-positive
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <br />
                            <div id="tool-tips">
                                <h2 className="iNGAGED-Typography-Heading3">
                                    <span className="bold-text">Tool Tips</span>
                                </h2>
                                <h2 className="iNGAGED-Typography-Heading5"></h2>

                                <h2 className="iNGAGED-Typography-Heading5">
                                    Used to provide context-related additional
                                    information to explain a function or
                                    feature. When to use them: To provide
                                    auxiliary explanation. To explain why a
                                    field/element is displayed. To explain a
                                    feature or function. To draw a users’
                                    attention to a new feature without
                                    interrupting their workflow. When not to use
                                    them: To hold information that is vital to
                                    complete a task. UX Trigger Icon Open the
                                    tooltip by clicking the info icon. Close
                                    tooltip by clicking anywhere on the page,
                                    including the info icon With Required:
                                    Bootstrap Icon: 12px. Info: info-circle. To
                                    see the principles of design for Tool-tips,{' '}
                                    <a
                                        href="https://www.figma.com/file/sZkGn2dTLeyfzhXupoTbYY/Draft-Style-Guide---iNGAGED?node-id=74111%3A3962&mode=dev"
                                        target="_blank"
                                        className="linked-text"
                                    >
                                        click here.
                                    </a>
                                </h2>
                                <hr />
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="186"
                                    height="68"
                                    viewBox="0 0 186 68"
                                    fill="none"
                                >
                                    <g>
                                        <path
                                            fillRule="evenodd"
                                            clipRule="evenodd"
                                            d="M6.23779 4.36808C5.36584 6.07937 5.36584 8.31958 5.36584 12.8V27L0.481487 32.6984C-0.160496 33.4474 -0.160496 34.5526 0.481487 35.3016L5.36584 41V55.2C5.36584 59.6804 5.36584 61.9206 6.23779 63.6319C7.00478 65.1372 8.22862 66.3611 9.73392 67.1281C11.4452 68 13.6854 68 18.1658 68H172.566C177.046 68 179.286 68 180.998 67.1281C182.503 66.3611 183.727 65.1372 184.494 63.6319C185.366 61.9206 185.366 59.6804 185.366 55.2V12.8C185.366 8.31958 185.366 6.07937 184.494 4.36808C183.727 2.86278 182.503 1.63893 180.998 0.871948C179.286 0 177.046 0 172.566 0H18.1658C13.6854 0 11.4452 0 9.73392 0.871948C8.22862 1.63893 7.00478 2.86278 6.23779 4.36808Z"
                                            fill="#1366FF"
                                        />
                                        <text
                                            x="52%"
                                            y="42%"
                                            dominantBaseline="left"
                                            textAnchor="left"
                                            fill="#FBFBFB"
                                            fontFamily="Inter"
                                            fontSize="14px"
                                            fontStyle="normal"
                                            fontWeight="500"
                                            lineHeight="1.2"
                                            textTransform="lowercase"
                                        >
                                            <tspan x="12%" dy="-0.5em">
                                                This is a sample - has
                                            </tspan>
                                            <tspan x="12%" dy="1em">
                                                not been used yet and{' '}
                                            </tspan>
                                            <tspan x="12%" dy="1em">
                                                {' '}
                                                may change
                                            </tspan>
                                        </text>
                                    </g>
                                </svg>

                                <br />
                                <br />
                                <div className="upload-file">
                                    <div className="text-container">
                                        <div className="box-button">
                                            <div className="custom-box">
                                                <div className="left-section3">
                                                    <p
                                                        onClick={e =>
                                                            getSCSSValue(e)
                                                        }
                                                        className="custom-text"
                                                    >
                                                        .ing-tool-tip
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <br />
                                <br />

                                <div>
                                    <i
                                        onMouseEnter={() =>
                                            setShowTooltip(true)
                                        }
                                        onMouseLeave={() =>
                                            setShowTooltip(false)
                                        }
                                        className="bi bi-info-circle"
                                        style={{
                                            color: 'rgb(19, 102, 255)',
                                            paddingRight: '13px',
                                        }}
                                    ></i>

                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="186"
                                        height="68"
                                        viewBox="0 0 186 68"
                                        fill="none"
                                    >
                                        <g
                                            style={{
                                                visibility: showTooltip
                                                    ? 'visible'
                                                    : 'hidden',
                                            }}
                                        >
                                            <path
                                                fillRule="evenodd"
                                                clipRule="evenodd"
                                                d="M6.23779 4.36808C5.36584 6.07937 5.36584 8.31958 5.36584 12.8V27L0.481487 32.6984C-0.160496 33.4474 -0.160496 34.5526 0.481487 35.3016L5.36584 41V55.2C5.36584 59.6804 5.36584 61.9206 6.23779 63.6319C7.00478 65.1372 8.22862 66.3611 9.73392 67.1281C11.4452 68 13.6854 68 18.1658 68H172.566C177.046 68 179.286 68 180.998 67.1281C182.503 66.3611 183.727 65.1372 184.494 63.6319C185.366 61.9206 185.366 59.6804 185.366 55.2V12.8C185.366 8.31958 185.366 6.07937 184.494 4.36808C183.727 2.86278 182.503 1.63893 180.998 0.871948C179.286 0 177.046 0 172.566 0H18.1658C13.6854 0 11.4452 0 9.73392 0.871948C8.22862 1.63893 7.00478 2.86278 6.23779 4.36808Z"
                                                fill="#1366FF"
                                            />
                                            <text
                                                x="52%"
                                                y="42%"
                                                dominantBaseline="left"
                                                textAnchor="left"
                                                fill="#FBFBFB"
                                                fontFamily="Inter"
                                                fontSize="14px"
                                                fontStyle="normal"
                                                fontWeight="500"
                                                lineHeight="1.2"
                                                textTransform="lowercase"
                                            >
                                                <tspan x="12%" dy="-0.5em">
                                                    This is a sample - has
                                                </tspan>
                                                <tspan x="12%" dy="1em">
                                                    not been used yet and{' '}
                                                </tspan>
                                                <tspan x="12%" dy="1em">
                                                    {' '}
                                                    may change
                                                </tspan>
                                            </text>
                                        </g>
                                    </svg>
                                </div>

                                <br />
                                <br />

                                <br />
                            </div>
                            <div id="tags">
                                <h2 className="iNGAGED-Typography-Heading3">
                                    <span className="bold-text">Tags</span>
                                </h2>
                                <h2 className="iNGAGED-Typography-Heading5">
                                    {' '}
                                    Tags: Removable: Clicking the X removes the
                                    whole tag. This variation is found on a
                                    forms page or anywhere that a user can
                                    add/remove groups. Badge: Badges are read
                                    only and display a status, value, group. Not
                                    Started - Grey. In Progress - Blue.
                                    Completed - Green. Completed with Errors -
                                    Yellow. Error - Red
                                </h2>
                                <hr />
                                <div className="box-container">
                                    {/* A tag with 'X' icon for tables */}
                                    <div className="box-container">
                                        <div className="upload-file">
                                            <button className="ing-button-tag">
                                                {' '}
                                                <i className="bi bi-x-lg"></i>{' '}
                                                HR_Team
                                            </button>
                                            <div className="text-container">
                                                <div className="box-button">
                                                    <div className="custom-box">
                                                        <div className="left-section">
                                                            <p
                                                                onClick={e =>
                                                                    getSCSSValue(
                                                                        e,
                                                                    )
                                                                }
                                                                className="custom-text"
                                                            >
                                                                .ing-button-tag-left
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* A tag with no icons */}
                                    <div className="box-container">
                                        <div className="upload-file">
                                            <button className="ing-button-tag">
                                                All Users
                                            </button>
                                            <div className="text-container">
                                                <div className="box-button">
                                                    <div className="custom-box">
                                                        <div className="left-section">
                                                            <p
                                                                onClick={e =>
                                                                    getSCSSValue(
                                                                        e,
                                                                    )
                                                                }
                                                                className="custom-text"
                                                            >
                                                                .ing-button-tag
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* 1. Active badge */}
                                    <div className="box-container">
                                        <div className="upload-file">
                                            <button className="ing-badge-active">
                                                Active
                                            </button>
                                            <div className="text-container">
                                                <div className="box-button">
                                                    <div className="custom-box">
                                                        <div className="left-section">
                                                            <p
                                                                onClick={e =>
                                                                    getSCSSValue(
                                                                        e,
                                                                    )
                                                                }
                                                                className="custom-text"
                                                            >
                                                                .ing-badge-active
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* 2. */}
                                    <div className="box-container">
                                        <div className="upload-file">
                                            <button className="ing-badge-complete-with-errors">
                                                Completed with Errors
                                            </button>
                                            <div className="text-container">
                                                <div className="box-button">
                                                    <div className="custom-box">
                                                        <div className="left-section">
                                                            <p
                                                                onClick={e =>
                                                                    getSCSSValue(
                                                                        e,
                                                                    )
                                                                }
                                                                className="custom-text"
                                                            >
                                                                .ing-badge-complete-with-errors
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* 3. */}
                                    <div className="box-container">
                                        <div className="upload-file">
                                            <button className="ing-badge-inactive">
                                                Inactive
                                            </button>
                                            <div className="text-container">
                                                <div className="box-button">
                                                    <div className="custom-box">
                                                        <div className="left-section">
                                                            <p
                                                                onClick={e =>
                                                                    getSCSSValue(
                                                                        e,
                                                                    )
                                                                }
                                                                className="custom-text"
                                                            >
                                                                .ing-badge-inactive
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* 4. */}
                                    <div className="box-container">
                                        <div className="upload-file">
                                            <button className="ing-badge-in-progress">
                                                In Progress
                                            </button>
                                            <div className="text-container">
                                                <div className="box-button">
                                                    <div className="custom-box">
                                                        <div className="left-section">
                                                            <p
                                                                onClick={e =>
                                                                    getSCSSValue(
                                                                        e,
                                                                    )
                                                                }
                                                                className="custom-text"
                                                            >
                                                                .ing-badge-in-progress
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* full row of elements */}
                                <div className="box-container">
                                    {/* 5. */}
                                    <div className="box-container">
                                        <div className="upload-file">
                                            <button className="ing-badge-pending">
                                                Pending
                                            </button>
                                            <div className="text-container">
                                                <div className="box-button">
                                                    <div className="custom-box">
                                                        <div className="left-section">
                                                            <p
                                                                onClick={e =>
                                                                    getSCSSValue(
                                                                        e,
                                                                    )
                                                                }
                                                                className="custom-text"
                                                            >
                                                                .ing-badge-pending
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="box-container">
                                        <div className="upload-file">
                                            <button className="ing-badge-pending">
                                                Pending
                                            </button>
                                            <div className="text-container">
                                                <div className="box-button">
                                                    <div className="custom-box">
                                                        <div className="left-section">
                                                            <p
                                                                onClick={e =>
                                                                    getSCSSValue(
                                                                        e,
                                                                    )
                                                                }
                                                                className="custom-text"
                                                            >
                                                                .ing-badge-pending
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* 6. */}
                                    <div className="box-container">
                                        <div className="upload-file">
                                            <button className="ing-badge-disabled">
                                                Disabled
                                            </button>
                                            <div className="text-container">
                                                <div className="box-button">
                                                    <div className="custom-box">
                                                        <div className="left-section">
                                                            <p
                                                                onClick={e =>
                                                                    getSCSSValue(
                                                                        e,
                                                                    )
                                                                }
                                                                className="custom-text"
                                                            >
                                                                .ing-badge-disabled
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* 7. */}
                                    <div className="box-container">
                                        <div className="upload-file">
                                            <button className="ing-badge-inv-sent">
                                                Invitation Sent
                                            </button>
                                            <div className="text-container">
                                                <div className="box-button">
                                                    <div className="custom-box">
                                                        <div className="left-section">
                                                            <p
                                                                onClick={e =>
                                                                    getSCSSValue(
                                                                        e,
                                                                    )
                                                                }
                                                                className="custom-text"
                                                            >
                                                                .ing-badge-inv-sent
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="box-container">
                                        <div className="upload-file">
                                            <button className="ing-badge-completed">
                                                Completed
                                            </button>
                                            <div className="text-container">
                                                <div className="box-button">
                                                    <div className="custom-box">
                                                        <div className="left-section">
                                                            <p
                                                                onClick={e =>
                                                                    getSCSSValue(
                                                                        e,
                                                                    )
                                                                }
                                                                className="custom-text"
                                                            >
                                                                .ing-badge-completed
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="box-container">
                                        <div className="upload-file">
                                            <button className="ing-badge-error">
                                                Error
                                            </button>
                                            <div className="text-container">
                                                <div className="box-button">
                                                    <div className="custom-box">
                                                        <div className="left-section">
                                                            <p
                                                                onClick={e =>
                                                                    getSCSSValue(
                                                                        e,
                                                                    )
                                                                }
                                                                className="custom-text"
                                                            >
                                                                .ing-badge-error
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="box-container">
                                    {/* 5. */}
                                    <div className="box-container">
                                        <div className="upload-file">
                                            <button className="ing-badge-error">
                                                Locked
                                            </button>
                                            <div className="text-container">
                                                <div className="box-button">
                                                    <div className="custom-box">
                                                        <div className="left-section">
                                                            <p
                                                                onClick={e =>
                                                                    getSCSSValue(
                                                                        e,
                                                                    )
                                                                }
                                                                className="custom-text"
                                                            >
                                                                .ing-badge-locked
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* 6. */}
                                    <div className="box-container">
                                        <div className="upload-file">
                                            <button className="ing-badge-template">
                                                Template
                                            </button>
                                            <div className="text-container">
                                                <div className="box-button">
                                                    <div className="custom-box">
                                                        <div className="left-section">
                                                            <p
                                                                onClick={e =>
                                                                    getSCSSValue(
                                                                        e,
                                                                    )
                                                                }
                                                                className="custom-text"
                                                            >
                                                                .ing-badge-template
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div id="icons">
                                <h2 className="iNGAGED-Typography-Heading1 iNGAGED-Primary-Color">
                                    <span className="bold-text">
                                        | Iconography
                                    </span>
                                </h2>
                                <h2 className="iNGAGED-Typography-Heading5">
                                    Icons are pulled from the Bootstrap icon
                                    library. Any additional icons from an
                                    outside library will used sparingly and are
                                    added seperately{' '}
                                    <a
                                        href="https://www.figma.com/design/sZkGn2dTLeyfzhXupoTbYY/Style-Guide---iNGAGED?node-id=73009-256&t=5rf8b9e78u4Oz0Af-0"
                                        target="_blank"
                                        className="linked-text"
                                    >
                                        {' '}
                                        click here
                                    </a>
                                    .
                                </h2>

                                <hr />

                                <div className="row-container">
                                    <div>
                                        <div className="box-container">
                                            <div className="box-container">
                                                <div className="float-end d-block align-items-center me-4">
                                                    <p>
                                                        {' '}
                                                        <i className="bi bi-check-lg me-2" />{' '}
                                                    </p>
                                                    <div className="text-container">
                                                        <div className="box-button">
                                                            <div className="custom-box">
                                                                <div className="left-section">
                                                                    <p
                                                                        onClick={e =>
                                                                            getSCSSValue(
                                                                                e,
                                                                            )
                                                                        }
                                                                        className="custom-text"
                                                                    >
                                                                        .ing-icon-save
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div>
                                        <div className="box-container">
                                            <div className="box-container">
                                                <div className="float-end d-block align-items-center me-4">
                                                    <p>
                                                        {' '}
                                                        <i className="bi bi-x-lg me-2" />{' '}
                                                    </p>
                                                    <div className="text-container">
                                                        <div className="box-button">
                                                            <div className="custom-box">
                                                                <div className="left-section">
                                                                    <p
                                                                        onClick={e =>
                                                                            getSCSSValue(
                                                                                e,
                                                                            )
                                                                        }
                                                                        className="custom-text"
                                                                    >
                                                                        .ing-icon-close
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div>
                                        <div className="box-container">
                                            <div className="box-container">
                                                <div className="float-end d-block align-items-center me-4">
                                                    <p>
                                                        {' '}
                                                        <i className="bi bi-trash me-2" />{' '}
                                                    </p>
                                                    <div className="text-container">
                                                        <div className="box-button">
                                                            <div className="custom-box">
                                                                <div className="left-section">
                                                                    <p
                                                                        onClick={e =>
                                                                            getSCSSValue(
                                                                                e,
                                                                            )
                                                                        }
                                                                        className="custom-text"
                                                                    >
                                                                        .ing-icon-delete
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div>
                                        <div className="box-container">
                                            <div className="box-container">
                                                <div className="float-end d-block align-items-center me-4">
                                                    <p>
                                                        {' '}
                                                        <i className="bi bi-copy me-2" />{' '}
                                                    </p>
                                                    <div className="text-container">
                                                        <div className="box-button">
                                                            <div className="custom-box">
                                                                <div className="left-section">
                                                                    <p
                                                                        onClick={e =>
                                                                            getSCSSValue(
                                                                                e,
                                                                            )
                                                                        }
                                                                        className="custom-text"
                                                                    >
                                                                        .ing-icon-duplicate
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div>
                                        <div className="box-container">
                                            <div className="box-container">
                                                <div className="float-end d-block align-items-center me-4">
                                                    <p>
                                                        {' '}
                                                        <i className="bi bi-cloud-arrow-down" />{' '}
                                                    </p>
                                                    <div className="text-container">
                                                        <div className="box-button">
                                                            <div className="custom-box">
                                                                <div className="left-section">
                                                                    <p
                                                                        onClick={e =>
                                                                            getSCSSValue(
                                                                                e,
                                                                            )
                                                                        }
                                                                        className="custom-text"
                                                                    >
                                                                        .ing-icon-ctas
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div>
                                        <div className="box-container">
                                            <div className="box-container">
                                                <div className="float-end d-block align-items-center me-4">
                                                    <p>
                                                        {' '}
                                                        <i className="bi bi-chevron-down"></i>{' '}
                                                    </p>
                                                    <div className="text-container">
                                                        <div className="box-button">
                                                            <div className="custom-box">
                                                                <div className="left-section">
                                                                    <p
                                                                        onClick={e =>
                                                                            getSCSSValue(
                                                                                e,
                                                                            )
                                                                        }
                                                                        className="custom-text"
                                                                    >
                                                                        .ing-icon-down
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div>
                                        <div className="box-container">
                                            <div className="box-container">
                                                <div className="float-end d-block align-items-center me-4">
                                                    <p>
                                                        {' '}
                                                        <i className="bi bi-chevron-up"></i>{' '}
                                                    </p>
                                                    <div className="text-container">
                                                        <div className="box-button">
                                                            <div className="custom-box">
                                                                <div className="left-section">
                                                                    <p
                                                                        onClick={e =>
                                                                            getSCSSValue(
                                                                                e,
                                                                            )
                                                                        }
                                                                        className="custom-text"
                                                                    >
                                                                        .ing-icon-up
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div>
                                        <div className="box-container">
                                            <div className="box-container">
                                                <div className="float-end d-block align-items-center me-4">
                                                    <p>
                                                        {' '}
                                                        <i className="bi bi-house-door-fill"></i>{' '}
                                                    </p>
                                                    <div className="text-container">
                                                        <div className="box-button">
                                                            <div className="custom-box">
                                                                <div className="left-section">
                                                                    <p
                                                                        onClick={e =>
                                                                            getSCSSValue(
                                                                                e,
                                                                            )
                                                                        }
                                                                        className="custom-text"
                                                                    >
                                                                        .ing-icon-home
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div>
                                        <div className="box-container">
                                            <div className="box-container">
                                                <div className="float-end d-block align-items-center me-4">
                                                    <p>
                                                        {' '}
                                                        <i className="bi bi-gear"></i>{' '}
                                                    </p>
                                                    <div className="text-container">
                                                        <div className="box-button">
                                                            <div className="custom-box">
                                                                <div className="left-section">
                                                                    <p
                                                                        onClick={e =>
                                                                            getSCSSValue(
                                                                                e,
                                                                            )
                                                                        }
                                                                        className="custom-text"
                                                                    >
                                                                        .ing-icon-settings
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div>
                                        <div className="box-container">
                                            <div className="box-container">
                                                <div className="float-end d-block align-items-center me-4">
                                                    <p>
                                                        {' '}
                                                        <i className="bi bi-columns-gap"></i>{' '}
                                                    </p>
                                                    <div className="text-container">
                                                        <div className="box-button">
                                                            <div className="custom-box">
                                                                <div className="left-section">
                                                                    <p
                                                                        onClick={e =>
                                                                            getSCSSValue(
                                                                                e,
                                                                            )
                                                                        }
                                                                        className="custom-text"
                                                                    >
                                                                        .ing-icon-portals
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div>
                                        <div className="box-container">
                                            <div className="box-container">
                                                <div className="float-end d-block align-items-center me-4">
                                                    <p>
                                                        {' '}
                                                        <i className="bi bi-diagram-3"></i>{' '}
                                                    </p>
                                                    <div className="text-container">
                                                        <div className="box-button">
                                                            <div className="custom-box">
                                                                <div className="left-section">
                                                                    <p
                                                                        onClick={e =>
                                                                            getSCSSValue(
                                                                                e,
                                                                            )
                                                                        }
                                                                        className="custom-text"
                                                                    >
                                                                        .ing-icon-diagram
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div>
                                        <div className="box-container">
                                            <div className="box-container">
                                                <div className="float-end d-block align-items-center me-4">
                                                    <p>
                                                        {' '}
                                                        <i className="bi bi-people"></i>{' '}
                                                    </p>
                                                    <div className="text-container">
                                                        <div className="box-button">
                                                            <div className="custom-box">
                                                                <div className="left-section">
                                                                    <p
                                                                        onClick={e =>
                                                                            getSCSSValue(
                                                                                e,
                                                                            )
                                                                        }
                                                                        className="custom-text"
                                                                    >
                                                                        .ing-icon-people
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* new icons 1 */}
                                    {/* <div>
                    <div className="box-container">
                      <div className="box-container">
                        <div className='float-end d-block align-items-center me-4'>
                          <p> <i className="bi bi-people"></i>  </p>
                          <div className="text-container">
                            <div className="box-button">
                              <div className="custom-box">
                                <div className="left-section">
                                  <p onClick={(e) => getSCSSValue(e)} className="custom-text">.ing-icon-people</p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div> */}
                                </div>
                            </div>
                            <div id="inputfields">
                                <h2 className="iNGAGED-Typography-Heading1 iNGAGED-Primary-Color">
                                    <span className="bold-text">| Forms</span>
                                </h2>
                                <h2 className="iNGAGED-Typography-Heading5">
                                    Used to collect information from the user by
                                    allowing user to input data. Forms allow the
                                    user to send information to a server. When a
                                    user is engaging with a form, <br />
                                    it is the center of attention. Forms should
                                    have visual prominence and centrality within
                                    the overall design.
                                </h2>

                                <br />
                                <h2 className="iNGAGED-Typography-Heading3">
                                    <span className="bold-text">
                                        Input Fields
                                    </span>
                                </h2>

                                <h2 className="iNGAGED-Typography-Heading5">
                                    {' '}
                                    There are many variations of Input Fields
                                    which will be described below and are user
                                    interactive. To see the principles of design
                                    for Forms,
                                    <a
                                        href="https://www.figma.com/file/sZkGn2dTLeyfzhXupoTbYY/Draft-Style-Guide---iNGAGED?node-id=74111%3A3962&mode=dev"
                                        target="_blank"
                                        className="linked-text"
                                    >
                                        {' '}
                                        click here.
                                    </a>
                                </h2>
                                <hr />

                                <div
                                    style={{
                                        width: '576px',
                                        minWidth: '300px',
                                        margin: 'auto',
                                    }}
                                >
                                    <h2 className="iNGAGED-Typography-Heading4">
                                        Active - Required
                                    </h2>

                                    <div className="file-form-label">
                                        Input Field Title
                                        <span
                                            style={{
                                                color: '#EF4E45',
                                                marginLeft: '4px',
                                                fontWeight: '500',
                                            }}
                                        >
                                            *
                                        </span>
                                    </div>
                                    <input
                                        style={{
                                            height: '48px',
                                            borderRadius: '12px',
                                            border: 'solid 1px rgba(47, 43, 67, 0.2)',
                                            paddingLeft: '16px',
                                            paddingRight: '16px',
                                            marginBottom: '10px',
                                        }}
                                        className="form-control"
                                        type="text"
                                        placeholder="Instructional Text"
                                        aria-label="Instructional Text"
                                        value={inputValue}
                                        onChange={handleInputChange}
                                        maxLength={characterLimit}
                                    />
                                    <h2
                                        className={`iNGAGED-Typography-Heading5 ${inputValue.length === characterLimit ? 'red-text' : ''}`}
                                    >
                                        Character Limit {inputValue.length}/
                                        {characterLimit}
                                    </h2>

                                    <div className="text-container">
                                        <div className="box-button">
                                            <div className="custom-box">
                                                <div className="left-section">
                                                    <p
                                                        onClick={e =>
                                                            getSCSSValue(e)
                                                        }
                                                        className="custom-text"
                                                    >
                                                        .ing-inputfield-name
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <br />

                                <div
                                    style={{
                                        width: '576px',
                                        minWidth: '300px',
                                        margin: 'auto',
                                    }}
                                >
                                    <h2 className="iNGAGED-Typography-Heading4">
                                        Inactive - Required
                                    </h2>
                                    <h2 className="iNGAGED-Typography-Heading5">
                                        When a field is required, but user
                                        hasn't completed previous inputs to turn
                                        field active
                                    </h2>

                                    <div className="file-form-label">
                                        Input Field Title
                                        <span
                                            style={{
                                                color: '#EF4E45',
                                                marginLeft: '4px',
                                                fontWeight: '500',
                                            }}
                                        >
                                            *
                                        </span>
                                    </div>

                                    <input
                                        style={{
                                            height: '48px',
                                            borderRadius: '12px',
                                            border: 'solid 1px rgba(47, 43, 67, 0.2)',
                                            paddingLeft: '16px',
                                            paddingRight: '16px',
                                            marginBottom: '10px',
                                        }}
                                        className="form-control-inactive"
                                        placeholder="Instructional Text"
                                        aria-label="Instructional Text"
                                        value={' '}
                                        maxLength={characterLimit}
                                    />
                                    <h2
                                        className={`iNGAGED-Typography-Heading5`}
                                    >
                                        Character Limit 0/20
                                    </h2>

                                    <div className="text-container">
                                        <div className="box-button">
                                            <div className="custom-box">
                                                <div className="left-section">
                                                    <p
                                                        onClick={e =>
                                                            getSCSSValue(e)
                                                        }
                                                        className="custom-text"
                                                    >
                                                        .ing-inputfield-name
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <br />

                                <div
                                    style={{
                                        width: '576px',
                                        minWidth: '300px',
                                        margin: 'auto',
                                    }}
                                >
                                    <h2 className="iNGAGED-Typography-Heading4">
                                        Validation Fail - Required
                                    </h2>
                                    <h2 className="iNGAGED-Typography-Heading5">
                                        When user submits a forms that's invalid
                                    </h2>

                                    <div className="file-form-label">
                                        Input Field Title{' '}
                                        <span
                                            style={{
                                                color: '#EF4E45',
                                                marginLeft: '4px',
                                                fontWeight: '500',
                                            }}
                                        >
                                            *
                                        </span>
                                    </div>

                                    <input
                                        style={{
                                            height: '48px',
                                            borderRadius: '12px',
                                            border: 'solid 1px rgba(47, 43, 67, 0.2)',
                                            paddingLeft: '16px',
                                            paddingRight: '16px',
                                            marginBottom: '10px',
                                        }}
                                        className="form-control"
                                        type="text"
                                        placeholder="Instructional Text"
                                        aria-label="Instructional Text"
                                        value={inputValueNil}
                                        // onChange={handleInputChange}
                                        maxLength={characterLimit}
                                    />
                                    <h2
                                        className={`iNGAGED-Typography-Heading5 ${inputValue.length <= characterLimit ? 'red-text' : ''}`}
                                    >
                                        Character Limit 0/20
                                    </h2>

                                    <div className="text-container">
                                        <div className="box-button">
                                            <div className="custom-box">
                                                <div className="left-section">
                                                    <p
                                                        onClick={e =>
                                                            getSCSSValue(e)
                                                        }
                                                        className="custom-text"
                                                    >
                                                        .ing-inputfield-name
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div
                                    style={{
                                        width: '576px',
                                        minWidth: '300px',
                                        margin: 'auto',
                                        paddingTop: '45px',
                                    }}
                                >
                                    <h2 className="iNGAGED-Typography-Heading4">
                                        {' '}
                                        Longer form text input - Active
                                    </h2>

                                    <div className="file-form-label">
                                        Description
                                    </div>

                                    <textarea
                                        className="form-control"
                                        placeholder="Larger text box for descriptions (optional)"
                                        id="floatingTextarea2"
                                        type="text"
                                        value={longInputValue}
                                        onChange={handleLongInputChange}
                                        maxLength={longCharacterLimit}
                                        style={{
                                            height: '100px',
                                            borderRadius: '12px',
                                            border: 'solid 1px rgba(47, 43, 67, 0.2)',
                                            resize: 'none',
                                            padding: '16px',
                                        }}
                                    ></textarea>
                                    <div
                                        style={{
                                            fontSize: '14px',
                                            fontWeight: '400',
                                            textAlign: 'left',
                                            marginLeft: '8px',
                                            marginTop: '8px',
                                        }}
                                    ></div>
                                    <h2
                                        className={`iNGAGED-Typography-Heading5 ${longInputValue.length === longCharacterLimit ? 'red-text' : ''}`}
                                    >
                                        Character Limit {longInputValue.length}/
                                        {longCharacterLimit}
                                    </h2>

                                    <div className="text-container">
                                        <div className="box-button">
                                            <div className="custom-box">
                                                <div className="left-section">
                                                    <p
                                                        onClick={e =>
                                                            getSCSSValue(e)
                                                        }
                                                        className="custom-text"
                                                    >
                                                        .ing-inputfield-description
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div
                                    style={{
                                        width: '576px',
                                        minWidth: '300px',
                                        margin: 'auto',
                                        paddingTop: '45px',
                                    }}
                                >
                                    <h2 className="iNGAGED-Typography-Heading4">
                                        {' '}
                                        Longer form text input - Inactive
                                    </h2>

                                    <div className="file-form-label">
                                        Description
                                    </div>

                                    <textarea
                                        className="form-control-inactive"
                                        placeholder="Larger text box for descriptions (optional)"
                                        id="floatingTextarea2"
                                        type="text"
                                        value={longInputValueNil}
                                        // onChange={handleLongInputChange}
                                        maxLength={longCharacterLimit}
                                        style={{
                                            height: '100px',
                                            borderRadius: '12px',
                                            border: 'solid 1px rgba(47, 43, 67, 0.2)',
                                            resize: 'none',
                                            padding: '16px',
                                        }}
                                    ></textarea>
                                    <div
                                        style={{
                                            fontSize: '14px',
                                            fontWeight: '400',
                                            textAlign: 'left',
                                            marginLeft: '8px',
                                            marginTop: '8px',
                                        }}
                                    ></div>
                                    <h2
                                        className={`iNGAGED-Typography-Heading5 ${longInputValue.length === longCharacterLimit ? 'red-text' : ''}`}
                                    >
                                        Character Limit 0/200
                                    </h2>

                                    <div className="text-container">
                                        <div className="box-button">
                                            <div className="custom-box">
                                                <div className="left-section">
                                                    <p
                                                        onClick={e =>
                                                            getSCSSValue(e)
                                                        }
                                                        className="custom-text"
                                                    >
                                                        .ing-inputfield-description
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <br />
                                <div
                                    style={{
                                        width: '576px',
                                        minWidth: '300px',
                                        margin: 'auto',
                                    }}
                                >
                                    <h2 className="iNGAGED-Typography-Heading4">
                                        Active - Not Required{' '}
                                    </h2>

                                    <div className="file-form-label">
                                        Input Field Title
                                    </div>
                                    <input
                                        style={{
                                            height: '48px',
                                            borderRadius: '12px',
                                            border: 'solid 1px rgba(47, 43, 67, 0.2)',
                                            paddingLeft: '16px',
                                            paddingRight: '16px',
                                            marginBottom: '10px',
                                        }}
                                        className="form-control"
                                        type="text"
                                        placeholder="Instructional Text"
                                        aria-label="Instructional Text"
                                        value={inputValueNotRequired}
                                        onChange={handleInputChangeNotRequired}
                                        maxLength={characterLimit}
                                    />
                                    <h2
                                        className={`iNGAGED-Typography-Heading5 ${inputValueNotRequired.length === characterLimit ? 'red-text' : ''}`}
                                    >
                                        Character Limit{' '}
                                        {inputValueNotRequired.length}/
                                        {characterLimit}
                                    </h2>

                                    <div className="text-container">
                                        <div className="box-button">
                                            <div className="custom-box">
                                                <div className="left-section">
                                                    <p
                                                        onClick={e =>
                                                            getSCSSValue(e)
                                                        }
                                                        className="custom-text"
                                                    >
                                                        .ing-inputfield-name
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div
                                    style={{
                                        width: '576px',
                                        minWidth: '300px',
                                        margin: 'auto',
                                    }}
                                >
                                    <h2 className="iNGAGED-Typography-Heading4">
                                        Inactive - Not Required{' '}
                                    </h2>

                                    <div className="file-form-label">
                                        Input Field Title
                                    </div>
                                    <input
                                        style={{
                                            height: '48px',
                                            borderRadius: '12px',
                                            border: 'solid 1px rgba(47, 43, 67, 0.2)',
                                            paddingLeft: '16px',
                                            paddingRight: '16px',
                                            marginBottom: '10px',
                                        }}
                                        className="form-control-inactive"
                                        placeholder="Instructional Text"
                                        aria-label="Instructional Text"
                                        value={' '}
                                        maxLength={characterLimit}
                                    />
                                    <h2
                                        className={`iNGAGED-Typography-Heading5`}
                                    >
                                        Character Limit 0/20
                                    </h2>

                                    <div className="text-container">
                                        <div className="box-button">
                                            <div className="custom-box">
                                                <div className="left-section">
                                                    <p
                                                        onClick={e =>
                                                            getSCSSValue(e)
                                                        }
                                                        className="custom-text"
                                                    >
                                                        .ing-inputfield-name
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <br />

                                <div
                                    style={{
                                        width: '576px',
                                        minWidth: '300px',
                                        margin: 'auto',
                                    }}
                                >
                                    <h2 className="iNGAGED-Typography-Heading4">
                                        Validation Fail - Not Required{' '}
                                    </h2>

                                    <div className="file-form-label">
                                        Input Field Title{' '}
                                    </div>
                                    <input
                                        style={{
                                            height: '48px',
                                            borderRadius: '12px',
                                            border: 'solid 1px rgba(47, 43, 67, 0.2)',
                                            paddingLeft: '16px',
                                            paddingRight: '16px',
                                            marginBottom: '10px',
                                        }}
                                        className="form-control"
                                        type="text"
                                        placeholder="Instructional Text"
                                        aria-label="Instructional Text"
                                        value={inputValueNil}
                                        // onChange={handleInputChange}
                                        maxLength={characterLimit}
                                    />
                                    <h2
                                        className={`iNGAGED-Typography-Heading5 ${inputValue.length <= characterLimit ? 'red-text' : ''}`}
                                    >
                                        Character Limit 0/20
                                    </h2>

                                    <div className="text-container">
                                        <div className="box-button">
                                            <div className="custom-box">
                                                <div className="left-section">
                                                    <p
                                                        onClick={e =>
                                                            getSCSSValue(e)
                                                        }
                                                        className="custom-text"
                                                    >
                                                        .ing-inputfield-name
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div
                                    style={{
                                        width: '576px',
                                        minWidth: '300px',
                                        margin: 'auto',
                                        paddingTop: '45px',
                                    }}
                                >
                                    <h2 className="iNGAGED-Typography-Heading4">
                                        Longer form text input - Validation
                                        Fail{' '}
                                    </h2>

                                    <div className="file-form-label">
                                        Description
                                    </div>

                                    <textarea
                                        className="form-control"
                                        placeholder="User attempts to input more that 200 characters. Dont allow them to enter more
                                        than the character limit and when they try to go over they should see the below
                                        character limit text in red."
                                        id="floatingTextarea2"
                                        type="text"
                                        value={longInputValueNil}
                                        // onChange={handleLongInputChange}
                                        maxLength={longCharacterLimit}
                                        style={{
                                            height: '100px',
                                            borderRadius: '12px',
                                            border: 'solid 1px rgba(47, 43, 67, 0.2)',
                                            resize: 'none',
                                            padding: '16px',
                                        }}
                                    ></textarea>
                                    <div
                                        style={{
                                            fontSize: '14px',
                                            fontWeight: '400',
                                            textAlign: 'left',
                                            marginLeft: '8px',
                                            marginTop: '8px',
                                        }}
                                    ></div>
                                    <h2
                                        className={`iNGAGED-Typography-Heading5 ${longInputValue.length <= longCharacterLimit ? 'red-text' : ''}`}
                                    >
                                        Character Limit 200/200
                                    </h2>

                                    <div className="text-container">
                                        <div className="box-button">
                                            <div className="custom-box">
                                                <div className="left-section">
                                                    <p
                                                        onClick={e =>
                                                            getSCSSValue(e)
                                                        }
                                                        className="custom-text"
                                                    >
                                                        .ing-inputfield-description
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="ing-inputfield-display-only">
                                    <p className="ing-inputfield-display-only-with-icon topText">
                                        Preferred Name
                                    </p>
                                    <p className="bottomText">555-555-5555</p>

                                    <div className="text-container">
                                        <div className="box-button">
                                            <div className="custom-box">
                                                <div className="left-section">
                                                    <p
                                                        onClick={e =>
                                                            getSCSSValue(e)
                                                        }
                                                        className="custom-text"
                                                    >
                                                        .ing-inputfield-display-only
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="ing-inputfield-display-only-with-icon">
                                    <div className="d-flex align-items-center">
                                        <i className="bi bi-telephone icon mr-2"></i>
                                        <p className="ing-inputfield-display-only-with-icon topText">
                                            Preferred Name
                                        </p>
                                    </div>
                                    <p className="bottomText">555-555-5555</p>

                                    <div className="text-container">
                                        <div className="box-button">
                                            <div className="custom-box">
                                                <div className="left-section">
                                                    <p
                                                        onClick={e =>
                                                            getSCSSValue(e)
                                                        }
                                                        className="custom-text"
                                                    >
                                                        .ing-inputfield-display-only-with-icon
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div id="dropdowns">
                                <h2 className="iNGAGED-Typography-Heading3">
                                    <span className="bold-text">Dropdowns</span>
                                </h2>
                                <hr />

                                {/*  */}
                                <div
                                    style={{
                                        width: '576px',
                                        minWidth: '300px',
                                        margin: 'auto',
                                    }}
                                >
                                    <div className="file-form-label">
                                        Dropdown{' '}
                                        <span
                                            style={{
                                                color: '#EF4E45',
                                                marginLeft: '4px',
                                                fontWeight: '500',
                                            }}
                                        >
                                            *
                                        </span>
                                    </div>

                                    <Dropdown
                                        defaultValue={'Select Option'}
                                        onChange={handleDropdownChange}
                                        options={[
                                            {
                                                value: 1,
                                                label: 'Option 1',
                                            },
                                            {
                                                value: 2,
                                                label: 'Option 2',
                                            },
                                            {
                                                value: 3,
                                                label: 'Option 3',
                                            },
                                        ]}
                                    />
                                </div>

                                <br />

                                <div></div>

                                <br />

                                {/* IF DROPDOWN VALIDATION FAILS, THEN REDISPLAY defaultValue */}
                            </div>
                            <div id="checkboxes">
                                <h2 className="iNGAGED-Typography-Heading3">
                                    <span className="bold-text">
                                        Check Boxes
                                    </span>
                                </h2>
                                <hr />

                                <h2 className="iNGAGED-Typography-Heading4">
                                    Unchecked{' '}
                                </h2>

                                <div className="checkbox"></div>
                                <br />

                                <h2 className="iNGAGED-Typography-Heading4">
                                    Selected
                                </h2>

                                <div>
                                    <div className="checkmark">
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="14"
                                            height="14"
                                            viewBox="0 0 14 14"
                                            fill="none"
                                        >
                                            <path
                                                d="M11.6673 3.5L5.25065 9.91667L2.33398 7"
                                                stroke="white"
                                                strokeWidth="2"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                        </svg>
                                    </div>
                                </div>
                                <br />

                                <h2 className="iNGAGED-Typography-Heading4">
                                    List Header{' '}
                                </h2>

                                <div className="checkbox-dash">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="14"
                                        height="14"
                                        viewBox="0 0 14 14"
                                        fill="none"
                                    >
                                        <path
                                            d="M2.91602 7H11.0827"
                                            stroke="#0070FF"
                                            strokeWidth="2"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                    </svg>
                                </div>
                                <br />

                                <h2 className="iNGAGED-Typography-Heading4">
                                    Validation Fail{' '}
                                </h2>

                                <div className="checkbox-fail"></div>
                                <br />

                                <h2 className="iNGAGED-Typography-Heading4">
                                    Disabled{' '}
                                </h2>

                                <div className="checkbox-invalid"></div>
                                <br />
                            </div>
                            <div id="radiobtns">
                                <h2 className="iNGAGED-Typography-Heading3">
                                    <span className="bold-text">
                                        Radio Buttons
                                    </span>
                                </h2>
                                <hr />

                                <h2 className="iNGAGED-Typography-Heading4">
                                    Unchecked{' '}
                                </h2>

                                <div className="radio-button">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="20"
                                        height="21"
                                        viewBox="0 0 20 21"
                                        fill="none"
                                    >
                                        <path
                                            d="M20 10.5C20 16.0228 15.5228 20.5 10 20.5C4.47715 20.5 0 16.0228 0 10.5C0 4.97715 4.47715 0.5 10 0.5C15.5228 0.5 20 4.97715 20 10.5ZM1.97104 10.5C1.97104 14.9343 5.56573 18.529 10 18.529C14.4343 18.529 18.029 14.9343 18.029 10.5C18.029 6.06573 14.4343 2.47104 10 2.47104C5.56573 2.47104 1.97104 6.06573 1.97104 10.5Z"
                                            fill="#667085"
                                        />
                                    </svg>
                                </div>

                                <br />

                                <h2 className="iNGAGED-Typography-Heading4">
                                    Selected{' '}
                                </h2>

                                <div className="radio-button">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="20"
                                        height="21"
                                        viewBox="0 0 20 21"
                                        fill="none"
                                    >
                                        <path
                                            d="M0 10.5C0 4.97715 4.47715 0.5 10 0.5C15.5228 0.5 20 4.97715 20 10.5C20 16.0228 15.5228 20.5 10 20.5C4.47715 20.5 0 16.0228 0 10.5Z"
                                            fill="#FAFAFA"
                                        />
                                        <path
                                            d="M20 10.5C20 16.0228 15.5228 20.5 10 20.5C4.47715 20.5 0 16.0228 0 10.5C0 4.97715 4.47715 0.5 10 0.5C15.5228 0.5 20 4.97715 20 10.5ZM1.97104 10.5C1.97104 14.9343 5.56573 18.529 10 18.529C14.4343 18.529 18.029 14.9343 18.029 10.5C18.029 6.06573 14.4343 2.47104 10 2.47104C5.56573 2.47104 1.97104 6.06573 1.97104 10.5Z"
                                            fill="#3B82F6"
                                        />
                                        <circle
                                            cx="10"
                                            cy="10.5"
                                            r="5"
                                            fill="#3B82F6"
                                        />
                                    </svg>
                                </div>
                                <br />

                                <h2 className="iNGAGED-Typography-Heading4">
                                    Disabled{' '}
                                </h2>

                                <div className="radio-button">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="20"
                                        height="21"
                                        viewBox="0 0 20 21"
                                        fill="none"
                                    >
                                        <path
                                            d="M0 10.5C0 4.97715 4.47715 0.5 10 0.5C15.5228 0.5 20 4.97715 20 10.5C20 16.0228 15.5228 20.5 10 20.5C4.47715 20.5 0 16.0228 0 10.5Z"
                                            fill="#FAFAFA"
                                        />
                                        <path
                                            d="M20 10.5C20 16.0228 15.5228 20.5 10 20.5C4.47715 20.5 0 16.0228 0 10.5C0 4.97715 4.47715 0.5 10 0.5C15.5228 0.5 20 4.97715 20 10.5ZM1.97104 10.5C1.97104 14.9343 5.56573 18.529 10 18.529C14.4343 18.529 18.029 14.9343 18.029 10.5C18.029 6.06573 14.4343 2.47104 10 2.47104C5.56573 2.47104 1.97104 6.06573 1.97104 10.5Z"
                                            fill="#D0D5DD"
                                        />
                                        <circle
                                            cx="10"
                                            cy="10.5"
                                            r="5"
                                            fill="#D0D5DD"
                                        />
                                    </svg>
                                </div>
                                <br />

                                <h2 className="iNGAGED-Typography-Heading4">
                                    Validation Failed{' '}
                                </h2>

                                <div className="radio-button">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="20"
                                        height="21"
                                        viewBox="0 0 20 21"
                                        fill="none"
                                    >
                                        <path
                                            d="M0 10.5C0 4.97715 4.47715 0.5 10 0.5C15.5228 0.5 20 4.97715 20 10.5C20 16.0228 15.5228 20.5 10 20.5C4.47715 20.5 0 16.0228 0 10.5Z"
                                            fill="#FAFAFA"
                                        />
                                        <path
                                            d="M20 10.5C20 16.0228 15.5228 20.5 10 20.5C4.47715 20.5 0 16.0228 0 10.5C0 4.97715 4.47715 0.5 10 0.5C15.5228 0.5 20 4.97715 20 10.5ZM1.97104 10.5C1.97104 14.9343 5.56573 18.529 10 18.529C14.4343 18.529 18.029 14.9343 18.029 10.5C18.029 6.06573 14.4343 2.47104 10 2.47104C5.56573 2.47104 1.97104 6.06573 1.97104 10.5Z"
                                            fill="#EF4E45"
                                        />
                                        <circle
                                            cx="10"
                                            cy="10.5"
                                            r="5"
                                            fill="#EF4E45"
                                        />
                                    </svg>
                                </div>
                                <br />
                            </div>
                            <div id="toggles">
                                <h2 className="iNGAGED-Typography-Heading3">
                                    <span className="bold-text">Toggles</span>
                                </h2>
                                <hr />

                                <h2 className="iNGAGED-Typography-Heading4">
                                    Active - Not Required{' '}
                                </h2>

                                <div className="toggle-switch">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="17"
                                        height="16"
                                        viewBox="0 0 17 16"
                                        fill="none"
                                    >
                                        <g filter="url(#filter0_dd_74349_1770)">
                                            <path
                                                d="M15 8C15 11.3137 12.3137 14 9 14C5.68629 14 3 11.3137 3 8C3 4.68629 5.68629 2 9 2C12.3137 2 15 4.68629 15 8Z"
                                                fill="white"
                                            />
                                        </g>
                                        <defs>
                                            <filter
                                                id="filter0_dd_74349_1770"
                                                x="0"
                                                y="0"
                                                width="18"
                                                height="18"
                                                filterUnits="userSpaceOnUse"
                                                color-interpolation-filters="sRGB"
                                            >
                                                <feFlood
                                                    flood-opacity="0"
                                                    result="BackgroundImageFix"
                                                />
                                                <feColorMatrix
                                                    in="SourceAlpha"
                                                    type="matrix"
                                                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                                    result="hardAlpha"
                                                />
                                                <feMorphology
                                                    radius="1"
                                                    operator="erode"
                                                    in="SourceAlpha"
                                                    result="effect1_dropShadow_74349_1770"
                                                />
                                                <feOffset dy="1" />
                                                <feGaussianBlur stdDeviation="1" />
                                                <feComposite
                                                    in2="hardAlpha"
                                                    operator="out"
                                                />
                                                <feColorMatrix
                                                    type="matrix"
                                                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
                                                />
                                                <feBlend
                                                    mode="normal"
                                                    in2="BackgroundImageFix"
                                                    result="effect1_dropShadow_74349_1770"
                                                />
                                                <feColorMatrix
                                                    in="SourceAlpha"
                                                    type="matrix"
                                                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                                    result="hardAlpha"
                                                />
                                                <feOffset dy="1" />
                                                <feGaussianBlur stdDeviation="1.5" />
                                                <feComposite
                                                    in2="hardAlpha"
                                                    operator="out"
                                                />
                                                <feColorMatrix
                                                    type="matrix"
                                                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
                                                />
                                                <feBlend
                                                    mode="normal"
                                                    in2="effect1_dropShadow_74349_1770"
                                                    result="effect2_dropShadow_74349_1770"
                                                />
                                                <feBlend
                                                    mode="normal"
                                                    in="SourceGraphic"
                                                    in2="effect2_dropShadow_74349_1770"
                                                    result="shape"
                                                />
                                            </filter>
                                        </defs>
                                    </svg>
                                </div>

                                <br />

                                <h2 className="iNGAGED-Typography-Heading4">
                                    Active - Not Required{' '}
                                </h2>

                                <div className="toggle-switch-red">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="17"
                                        height="16"
                                        viewBox="0 0 17 16"
                                        fill="none"
                                    >
                                        <g filter="url(#filter0_dd_74349_1786)">
                                            <circle
                                                cx="8"
                                                cy="8"
                                                r="6"
                                                fill="white"
                                            />
                                        </g>
                                    </svg>
                                </div>
                            </div>
                            <br />
                            <br />
                            <div id="validations">
                                <h2 className="iNGAGED-Typography-Heading1 iNGAGED-Primary-Color">
                                    <span className="bold-text">| Alerts</span>
                                </h2>
                                <h2 className="iNGAGED-Typography-Heading5">
                                    Alerts are graceful ways to handle user
                                    errors. Below are the different types and
                                    their UX.
                                </h2>
                            </div>
                            {/* 
              <div id="messaging">
                <br />
                <h2 className="iNGAGED-Typography-Heading3"><span className="bold-text">2) Messaging</span></h2>
                <h2 className="iNGAGED-Typography-Heading5"><i className="bi bi-info-circle-fill"></i> <a href="https://www.figma.com/file/sZkGn2dTLeyfzhXupoTbYY/Style-Guide---iNGAGED?type=design&node-id=74075-3432&mode=design&t=qNxFAzPdhm1MfJ6y-0" target="_blank" className="linked-text">Figma </a></h2>
                <h2 className="iNGAGED-Typography-Heading5">Form validations provide information just in time and displaying and conveying messages/error messages
                  in plain and straightforward language for non-technical users to understand.</h2>
              </div> */}
                            {/* <div id="popups">
                <br />
                <h2 className="iNGAGED-Typography-Heading3"><span className="bold-text">3) Pop Up Action Required</span></h2>
                <h2 className="iNGAGED-Typography-Heading5"><i className="bi bi-info-circle-fill"></i> <a href="https://www.figma.com/file/sZkGn2dTLeyfzhXupoTbYY/Style-Guide---iNGAGED?node-id=73626%3A419&mode=dev" target="_blank" className="linked-text">Figma </a></h2>
                <h2 className="iNGAGED-Typography-Heading5">Form validations provide information just in time and displaying and conveying messages/error messages
                  in plain and straightforward language for non-technical users to understand.</h2>
              </div>

              <div id="popups">
                <br />
                <h2 className="iNGAGED-Typography-Heading3"><span className="bold-text">3) Pop Up Action Required</span></h2>
                <h2 className="iNGAGED-Typography-Heading5"><i className="bi bi-info-circle-fill"></i> <a href="https://www.figma.com/file/sZkGn2dTLeyfzhXupoTbYY/Style-Guide---iNGAGED?type=design&node-id=74075-3432&mode=design&t=qNxFAzPdhm1MfJ6y-0" target="_blank" className="linked-text">Figma </a></h2>
                <h2 className="iNGAGED-Typography-Heading5">Form validations provide information just in time and displaying and conveying messages/error messages
                  in plain and straightforward language for non-technical users to understand.</h2>
              </div> */}
                            {/* <div id="confirm">
                <br />
                <h2 className="iNGAGED-Typography-Heading3"><span className="bold-text"> 4) Acknowledgements (confirm) </span></h2>
                <h2 className="iNGAGED-Typography-Heading5"><i className="bi bi-info-circle-fill"></i> <a href="https://www.figma.com/file/sZkGn2dTLeyfzhXupoTbYY/Style-Guide---iNGAGED?type=design&node-id=74075-3432&mode=design&t=qNxFAzPdhm1MfJ6y-0" target="_blank" className="linked-text">Figma </a></h2>
                <h2 className="iNGAGED-Typography-Heading5">Form validations provide information just in time and displaying and conveying messages/error messages
                  in plain and straightforward language for non-technical users to understand.</h2>
              </div>

              <div id="toasts">
                <br />
                <h2 className="iNGAGED-Typography-Heading3"><span className="bold-text"> 5) Toasts (confirm) </span></h2>
                <h2 className="iNGAGED-Typography-Heading5"><i className="bi bi-info-circle-fill"></i> <a href="https://www.figma.com/file/sZkGn2dTLeyfzhXupoTbYY/Style-Guide---iNGAGED?node-id=73610%3A15552&mode=dev" target="_blank" className="linked-text">Figma </a></h2>
                <h2 className="iNGAGED-Typography-Heading5">Form validations provide information just in time and displaying and conveying messages/error messages
                  in plain and straightforward language for non-technical users to understand.</h2>
              </div> */}
                            <br />
                            <div className="ing-toast-error">
                                <div className="ing-toast-error-leftElement">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="16"
                                        height="16"
                                        viewBox="0 0 16 16"
                                        fill="none"
                                    >
                                        <path
                                            d="M7.00506 3.0994C6.9462 2.51077 7.40844 2 8 2C8.59156 2 9.0538 2.51077 8.99494 3.0994L8.60741 9.4503C8.5762 9.76236 8.31361 10 8 10C7.68639 10 7.4238 9.76236 7.39259 9.4503L7.00506 3.0994Z"
                                            fill="white"
                                        />
                                        <path
                                            d="M7 12C7 11.4477 7.44772 11 8 11C8.55228 11 9 11.4477 9 12C9 12.5523 8.55228 13 8 13C7.44772 13 7 12.5523 7 12Z"
                                            fill="white"
                                        />
                                    </svg>
                                </div>
                                <div className="ing-toast-error-content">
                                    <div className="ing-toast-error-text">
                                        <h2 className="ing-toast-error-title">
                                            Error
                                        </h2>
                                        <p className="ing-toast-error-subtitle">
                                            Enter a valid username
                                        </p>
                                    </div>
                                    <div className="ing-toast-error-close">
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="16"
                                            height="16"
                                            viewBox="0 0 16 16"
                                            fill="none"
                                        >
                                            <path
                                                d="M4.64645 4.64645C4.84171 4.45118 5.15829 4.45118 5.35355 4.64645L8 7.29289L10.6464 4.64645C10.8417 4.45118 11.1583 4.45118 11.3536 4.64645C11.5488 4.84171 11.5488 5.15829 11.3536 5.35355L8.70711 8L11.3536 10.6464C11.5488 10.8417 11.5488 11.1583 11.3536 11.3536C11.1583 11.5488 10.8417 11.5488 10.6464 11.3536L8 8.70711L5.35355 11.3536C5.15829 11.5488 4.84171 11.5488 4.64645 11.3536C4.45118 11.1583 4.45118 10.8417 4.64645 10.6464L7.29289 8L4.64645 5.35355C4.45118 5.15829 4.45118 4.84171 4.64645 4.64645Z"
                                                fill="black"
                                            />
                                        </svg>
                                    </div>
                                </div>
                            </div>
                            <br />
                            <div className="ing-toast-success">
                                <div className="ing-toast-success-leftElement">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="16"
                                        height="16"
                                        viewBox="0 0 16 16"
                                        fill="none"
                                    >
                                        <path
                                            d="M12.7365 3.96967C13.0255 3.67678 13.4942 3.67678 13.7832 3.96967C14.0687 4.25897 14.0722 4.72582 13.7937 5.01947L7.88025 12.0097C7.87456 12.0169 7.86848 12.0238 7.86205 12.0303C7.573 12.3232 7.10437 12.3232 6.81532 12.0303L3.21678 8.38388C2.92774 8.09099 2.92774 7.61612 3.21678 7.32322C3.50583 7.03033 3.97446 7.03033 4.26351 7.32322L7.31638 10.4167L12.7169 3.9921C12.723 3.98424 12.7295 3.97674 12.7365 3.96967Z"
                                            fill="white"
                                        />
                                    </svg>
                                </div>
                                <div className="ing-toast-success-content">
                                    <div className="ing-toast-success-text">
                                        <h2 className="ing-toast-success-title">
                                            Success
                                        </h2>
                                        <p className="ing-toast-success-subtitle">
                                            Your asset has been successfully
                                            uploaded
                                        </p>
                                    </div>
                                    <div className="ing-toast-success-close">
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="16"
                                            height="16"
                                            viewBox="0 0 16 16"
                                            fill="none"
                                        >
                                            <path
                                                d="M4.64645 4.64645C4.84171 4.45118 5.15829 4.45118 5.35355 4.64645L8 7.29289L10.6464 4.64645C10.8417 4.45118 11.1583 4.45118 11.3536 4.64645C11.5488 4.84171 11.5488 5.15829 11.3536 5.35355L8.70711 8L11.3536 10.6464C11.5488 10.8417 11.5488 11.1583 11.3536 11.3536C11.1583 11.5488 10.8417 11.5488 10.6464 11.3536L8 8.70711L5.35355 11.3536C5.15829 11.5488 4.84171 11.5488 4.64645 11.3536C4.45118 11.1583 4.45118 10.8417 4.64645 10.6464L7.29289 8L4.64645 5.35355C4.45118 5.15829 4.45118 4.84171 4.64645 4.64645Z"
                                                fill="black"
                                            />
                                        </svg>
                                    </div>
                                </div>
                            </div>
                            <br />
                            <div className="ing-toast-warning">
                                <div className="ing-toast-warning-leftElement">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="16"
                                        height="16"
                                        viewBox="0 0 16 16"
                                        fill="none"
                                    >
                                        <path
                                            d="M7.00506 3.0994C6.9462 2.51077 7.40844 2 8 2C8.59156 2 9.0538 2.51077 8.99494 3.0994L8.60741 9.4503C8.5762 9.76236 8.31361 10 8 10C7.68639 10 7.4238 9.76236 7.39259 9.4503L7.00506 3.0994Z"
                                            fill="white"
                                        />
                                        <path
                                            d="M7 12C7 11.4477 7.44772 11 8 11C8.55228 11 9 11.4477 9 12C9 12.5523 8.55228 13 8 13C7.44772 13 7 12.5523 7 12Z"
                                            fill="white"
                                        />
                                    </svg>
                                </div>
                                <br />
                                <div className="ing-toast-warning-content">
                                    <div className="ing-toast-warning-text">
                                        <h2 className="ing-toast-warning-title">
                                            Warning
                                        </h2>
                                        <p className="ing-toast-warning-subtitle">
                                            You have 1 more login attempt
                                        </p>
                                    </div>
                                    <div className="ing-toast-warning-close">
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="16"
                                            height="16"
                                            viewBox="0 0 16 16"
                                            fill="none"
                                        >
                                            <path
                                                d="M4.64645 4.64645C4.84171 4.45118 5.15829 4.45118 5.35355 4.64645L8 7.29289L10.6464 4.64645C10.8417 4.45118 11.1583 4.45118 11.3536 4.64645C11.5488 4.84171 11.5488 5.15829 11.3536 5.35355L8.70711 8L11.3536 10.6464C11.5488 10.8417 11.5488 11.1583 11.3536 11.3536C11.1583 11.5488 10.8417 11.5488 10.6464 11.3536L8 8.70711L5.35355 11.3536C5.15829 11.5488 4.84171 11.5488 4.64645 11.3536C4.45118 11.1583 4.45118 10.8417 4.64645 10.6464L7.29289 8L4.64645 5.35355C4.45118 5.15829 4.45118 4.84171 4.64645 4.64645Z"
                                                fill="black"
                                            />
                                        </svg>
                                    </div>
                                </div>
                            </div>
                            <br />
                            <div className="ing-toast-info">
                                <div className="ing-toast-info-leftElement">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="16"
                                        height="16"
                                        viewBox="0 0 16 16"
                                        fill="none"
                                    >
                                        <path
                                            d="M9.70753 6.07474L6.68433 6.45361L6.57608 6.95619L7.17144 7.06443C7.55804 7.15722 7.63536 7.29639 7.55031 7.68299L6.57608 12.2603C6.32093 13.4433 6.71526 14 7.64309 14C8.36216 14 9.19722 13.6675 9.57608 13.2113L9.69206 12.6624C9.42918 12.8943 9.04258 12.9871 8.78742 12.9871C8.42402 12.9871 8.29258 12.732 8.38536 12.2835L9.70753 6.07474Z"
                                            fill="white"
                                        />
                                        <path
                                            d="M9.79897 3.31959C9.79897 4.04838 9.20817 4.63918 8.47938 4.63918C7.75059 4.63918 7.15979 4.04838 7.15979 3.31959C7.15979 2.5908 7.75059 2 8.47938 2C9.20817 2 9.79897 2.5908 9.79897 3.31959Z"
                                            fill="white"
                                        />
                                    </svg>
                                </div>
                                <div className="ing-toast-info-content">
                                    <div className="ing-toast-info-text">
                                        <h2 className="ing-toast-info-title">
                                            Info
                                        </h2>
                                        <p className="ing-toast-info-subtitle">
                                            3 people have responded to your post
                                        </p>
                                    </div>
                                    <div className="ing-toast-info-close">
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="16"
                                            height="16"
                                            viewBox="0 0 16 16"
                                            fill="none"
                                        >
                                            <path
                                                d="M4.64645 4.64645C4.84171 4.45118 5.15829 4.45118 5.35355 4.64645L8 7.29289L10.6464 4.64645C10.8417 4.45118 11.1583 4.45118 11.3536 4.64645C11.5488 4.84171 11.5488 5.15829 11.3536 5.35355L8.70711 8L11.3536 10.6464C11.5488 10.8417 11.5488 11.1583 11.3536 11.3536C11.1583 11.5488 10.8417 11.5488 10.6464 11.3536L8 8.70711L5.35355 11.3536C5.15829 11.5488 4.84171 11.5488 4.64645 11.3536C4.45118 11.1583 4.45118 10.8417 4.64645 10.6464L7.29289 8L4.64645 5.35355C4.45118 5.15829 4.45118 4.84171 4.64645 4.64645Z"
                                                fill="black"
                                            />
                                        </svg>
                                    </div>
                                </div>
                            </div>
                            <br />
                            <div id="Pagination">
                                <h2 className="iNGAGED-Typography-Heading1 iNGAGED-Primary-Color">
                                    <span className="bold-text">
                                        | Pagination
                                    </span>
                                </h2>
                                <h2 className="iNGAGED-Typography-Heading5">
                                    The process of putting numbers on successive
                                    pages and it's also the sequence of numbers
                                    itself.
                                </h2>
                            </div>
                            <div className="pagination">
                                <button className="back-page-button">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="22"
                                        height="22"
                                        viewBox="0 0 22 22"
                                        fill="none"
                                    >
                                        <path
                                            d="M14.3963 6.7925L13.1038 5.5L7.60376 11L13.1038 16.5L14.3963 15.2075L10.1979 11L14.3963 6.7925Z"
                                            fill="white"
                                        />
                                    </svg>
                                </button>
                                <span className="page-label">Page:</span>
                                <input
                                    className="page-input"
                                    min="1"
                                    max="50"
                                />
                                <span className="page-label2">of 50</span>
                                <button className="back-page-button">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="22"
                                        height="22"
                                        viewBox="0 0 22 22"
                                        fill="none"
                                    >
                                        <path
                                            d="M7.60376 15.2075L8.89626 16.5L14.3963 11L8.89626 5.5L7.60376 6.7925L11.8021 11L7.60376 15.2075Z"
                                            fill="white"
                                        />
                                    </svg>
                                </button>
                            </div>
                            <br /> <br />
                            <div id="Mobile">
                                <h2 className="iNGAGED-Typography-Heading1 iNGAGED-Primary-Color">
                                    <span className="bold-text">| Mobile </span>
                                </h2>
                                <h2 className="iNGAGED-Typography-Heading5">
                                    UI/UX for Mobile Features of iNGAGED.
                                </h2>
                            </div>
                            <div className="ing-tabs">
                                <div className="ing-tab">Dashboard</div>
                                <div className="ing-tab">Safety</div>
                                <div className="ing-tab">Managers</div>
                                <div className="ing-tab">Sales</div>
                            </div>
                            <br />
                            <br />
                            <div className="ing-bottom-tabs">
                                <div
                                    className="ing-bottom-tab"
                                    onClick={() => changeTab(1)}
                                >
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="15"
                                        height="16"
                                        viewBox="0 0 15 16"
                                        fill="none"
                                    >
                                        <path
                                            d="M7.2381 8C9.23684 8 10.8571 6.20914 10.8571 4C10.8571 1.79086 9.23684 0 7.2381 0C5.23935 0 3.61905 1.79086 3.61905 4C3.61905 6.20914 5.23935 8 7.2381 8ZM9.65079 4C9.65079 5.47276 8.57059 6.66667 7.2381 6.66667C5.9056 6.66667 4.8254 5.47276 4.8254 4C4.8254 2.52724 5.9056 1.33333 7.2381 1.33333C8.57059 1.33333 9.65079 2.52724 9.65079 4Z"
                                            fill="#2F2B43"
                                        />
                                        <path
                                            d="M14.4762 14.6667C14.4762 16 13.2698 16 13.2698 16H1.20635C1.20635 16 0 16 0 14.6667C0 13.3333 1.20635 9.33333 7.2381 9.33333C13.2698 9.33333 14.4762 13.3333 14.4762 14.6667ZM13.2698 14.662C13.2681 14.333 13.0843 13.3473 12.266 12.4428C11.4792 11.5731 9.99955 10.6667 7.23808 10.6667C4.47662 10.6667 2.997 11.5731 2.21015 12.4428C1.39183 13.3473 1.20807 14.333 1.20635 14.662H13.2698Z"
                                            fill="#2F2B43"
                                        />
                                    </svg>
                                    <span className="ing-bottom-tab-text">
                                        Home
                                    </span>
                                </div>
                                <div
                                    className="ing-bottom-tab"
                                    onClick={() => changeTab(2)}
                                >
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="15"
                                        height="16"
                                        viewBox="0 0 15 16"
                                        fill="none"
                                    >
                                        <path
                                            d="M7.2381 8C9.23684 8 10.8571 6.20914 10.8571 4C10.8571 1.79086 9.23684 0 7.2381 0C5.23935 0 3.61905 1.79086 3.61905 4C3.61905 6.20914 5.23935 8 7.2381 8ZM9.65079 4C9.65079 5.47276 8.57059 6.66667 7.2381 6.66667C5.9056 6.66667 4.8254 5.47276 4.8254 4C4.8254 2.52724 5.9056 1.33333 7.2381 1.33333C8.57059 1.33333 9.65079 2.52724 9.65079 4Z"
                                            fill="#2F2B43"
                                        />
                                        <path
                                            d="M14.4762 14.6667C14.4762 16 13.2698 16 13.2698 16H1.20635C1.20635 16 0 16 0 14.6667C0 13.3333 1.20635 9.33333 7.2381 9.33333C13.2698 9.33333 14.4762 13.3333 14.4762 14.6667ZM13.2698 14.662C13.2681 14.333 13.0843 13.3473 12.266 12.4428C11.4792 11.5731 9.99955 10.6667 7.23808 10.6667C4.47662 10.6667 2.997 11.5731 2.21015 12.4428C1.39183 13.3473 1.20807 14.333 1.20635 14.662H13.2698Z"
                                            fill="#2F2B43"
                                        />
                                    </svg>
                                    <span className="ing-bottom-tab-text">
                                        Inbox
                                    </span>
                                </div>
                                <div
                                    className="ing-bottom-tab"
                                    onClick={() => changeTab(3)}
                                >
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="15"
                                        height="16"
                                        viewBox="0 0 15 16"
                                        fill="none"
                                    >
                                        <path
                                            d="M7.2381 8C9.23684 8 10.8571 6.20914 10.8571 4C10.8571 1.79086 9.23684 0 7.2381 0C5.23935 0 3.61905 1.79086 3.61905 4C3.61905 6.20914 5.23935 8 7.2381 8ZM9.65079 4C9.65079 5.47276 8.57059 6.66667 7.2381 6.66667C5.9056 6.66667 4.8254 5.47276 4.8254 4C4.8254 2.52724 5.9056 1.33333 7.2381 1.33333C8.57059 1.33333 9.65079 2.52724 9.65079 4Z"
                                            fill="#2F2B43"
                                        />
                                        <path
                                            d="M14.4762 14.6667C14.4762 16 13.2698 16 13.2698 16H1.20635C1.20635 16 0 16 0 14.6667C0 13.3333 1.20635 9.33333 7.2381 9.33333C13.2698 9.33333 14.4762 13.3333 14.4762 14.6667ZM13.2698 14.662C13.2681 14.333 13.0843 13.3473 12.266 12.4428C11.4792 11.5731 9.99955 10.6667 7.23808 10.6667C4.47662 10.6667 2.997 11.5731 2.21015 12.4428C1.39183 13.3473 1.20807 14.333 1.20635 14.662H13.2698Z"
                                            fill="#2F2B43"
                                        />
                                    </svg>
                                    <span className="ing-bottom-tab-text">
                                        Tab 3
                                    </span>
                                </div>
                            </div>
                            <br />
                            <div className="box-container">
                                <div className="upload-file">
                                    <div className="button-container">
                                        <button
                                            className="ing-button-primary-none-mobile"
                                            type="submit"
                                        >
                                            No Icon
                                        </button>
                                    </div>
                                    <div className="text-container">
                                        <div className="box-button">
                                            <div className="custom-box">
                                                {/* <div className="left-section">
                              <p onClick={(e) => getSCSSValue(e)} className="custom-text">.ing-button-primary-none</p>
                            </div> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default BrandingPage;
